import { component } from "picoapp";
import React, { useState, useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
// import { Stage, Layer, Image as KonvaImage, Text as KonvaText, Group, Transformer } from "react-konva";
// import useImage from "use-image";
import styled, { createGlobalStyle } from "styled-components";
import { Cloudinary } from '@cloudinary/url-gen';
import { auto, scale } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import opentype from 'opentype.js';

let mysteryImg = "https://cdn.shopify.com/s/files/1/0110/7827/1033/files/iconmonstr-help-1.svg?v=1732310678";

// Global styles for scroll lock
const GlobalScrollLock = createGlobalStyle`
  html.customizer-scroll-lock,
  body.customizer-scroll-lock {
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
    height: 100% !important;
  }
`;

// Styled Components
const CustomizerContainer = styled.div`
  display: flex;
  gap: 0;
  margin: 0;
  padding: 0;
  font-family: 'aktiv-grotesk', sans-serif;
  background: white;
  min-height: 100%;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const CanvasSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  
  @media (max-width: 768px) {
    padding: 1rem;
    min-height: 50vh;
  }
`;

const ControlsSection = styled.div`
  width: 500px;
  background: white;
  border-left: 1px solid #e5e7eb;
  overflow-y: auto;
  max-height: 100vh;
  position: relative;
  
  @media (max-width: 768px) {
    width: 100%;
    border-left: none;
    border-top: 1px solid #e5e7eb;
  }
`;

const CanvasWrapper = styled.div`
  border: none;
  border-radius: 0;
  overflow: hidden;
  background: white;
  position: relative;
  width: 100%;
  // height: 100%;
  min-height: 600px;
  
  @media (max-width: 768px) {
    min-height: 400px;
    // max-height: 400px;
    width: 400px;
    height: 100%;
  }
`;



const StepContainer = styled.div`
  margin-bottom: 0;
  padding: 12px;
  border: none;
  border-bottom: 1px solid #e5e7eb;
  border-radius: 0;
  background: white;
  
  @media (max-width: 768px) {
    padding: 12px;
  }
`;

const StepTitle = styled.h3`
  font-size: 12px;
  font-weight: 400;
  margin-bottom: .75rem;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const ProductGrid = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  
  @media (max-width: 768px) {
    gap: 0.25rem;
  }
`;

const ProductCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border: 1px solid ${props => props.$selected ? '#1e40af' : '#e5e7eb'};
  border-radius: 4px;
  background: ${props => props.$selected ? '#1e40af' : 'white'};
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 90px;
  flex-shrink: 1;
  
  &:hover {
    border-color: #1e40af;
    background: ${props => props.$selected ? '#1e40af' : '#f8fafc'};
  }
  
  img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    margin-bottom: 0.5rem;
  }
  
  span {
    font-size: 0.75rem;
    text-align: center;
    color: ${props => props.$selected ? 'white' : '#374151'};
    font-weight: 500;
    line-height: 1.2;
  }
  
  @media (max-width: 768px) {
    min-width: 70px;
    padding: 0.25rem;
    
    img {
      width: 40px;
      height: 40px;
      margin-bottom: 0.25rem;
    }
    
    span {
      font-size: 0.625rem;
    }
  }
`;

const ColorGrid = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 4px 0;
  
  @media (max-width: 768px) {
    gap: 0.25rem;
    padding-bottom: 0.25rem;
  }
`;

const ColorCard = styled.button`
  width: 50px;
  height: 50px;
  border: 2px solid ${props => props.$selected ? '#1e40af' : '#e5e7eb'};
  border-radius: 50%;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  
  &:hover {
    border-color: #1e40af;
    transform: scale(1.05);
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: translateY(10px) scale(3);
  }
  
  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  @media (max-width: 768px) {
    padding: 0.625rem;
    font-size: 0.75rem;
    margin-bottom: 0.75rem;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  background: white;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
  
  @media (max-width: 768px) {
    padding: 0.625rem;
    font-size: 0.75rem;
    margin-bottom: 0.75rem;
  }
`;

const Button = styled.button`
  width: fit-content;
  padding: 0.875rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: #2563eb;
  }
  
  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
  
  @media (max-width: 768px) {
    padding: 0.75rem;
    font-size: 0.75rem;
  }
`;

const UploadButton = styled.input`
  display: none;
`;

const UploadLabel = styled.label`
  display: block;
  width: 100%;
  padding: 0.875rem;
  background: #f3f4f6;
  color: #374151;
  border: 2px dashed #d1d5db;
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #3b82f6;
    background: #eff6ff;
  }
`;

const ProcessingContainer = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  margin: 0.5rem 0;
`;

const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #1d4ed8);
  width: ${props => props.progress}%;
  transition: width 0.3s ease;
`;

// ThresholdSlider removed - using fixed threshold

const PreviewContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  align-items: center;

  .customizer-preview-item {
    width: 50%;
  }
`;

const PreviewImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: white;
`;

// New full-screen review modal for processed logos
const ReviewOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #e8f0f5;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const ReviewHeader = styled.div`
  padding: 1rem 1.5rem;
  text-align: center;
  background: #e8f0f5;
  
  p {
    font-size: 0.875rem;
    color: #4b5563;
    margin: 0;
  }
`;

const ReviewToolbar = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: #e8f0f5;
`;

const ToolbarButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #1f2937;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  transition: all 0.15s ease;
  
  &:hover {
    background: #f9fafb;
    border-color: #9ca3af;
  }
  
  &:active {
    background: #f3f4f6;
  }
  
  &.active {
    background: #1e3a5f;
    color: white;
    border-color: #1e3a5f;
    
    &:hover {
      background: #152a45;
    }
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

const ReviewImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2rem;
  overflow: auto;
  background: #e8f0f5;
`;

const ReviewImageWrapper = styled.div`
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ReviewImage = styled.img`
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  /* Apply filter to show as black instead of metallic silver */
  filter: brightness(0) saturate(100%);
`;

const ReviewFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem;
  background: #e8f0f5;
`;

const ReviewButton = styled.button`
  padding: 0.875rem 2.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: all 0.15s ease;
  
  ${props => props.$primary ? `
    background: #1e3a5f;
    color: white;
    border: none;
    
    &:hover {
      background: #152a45;
    }
  ` : `
    background: white;
    color: #1f2937;
    border: 1px solid #d1d5db;
    
    &:hover {
      background: #f9fafb;
      border-color: #9ca3af;
    }
  `}
`;

// Threshold slider modal
const ThresholdModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  z-index: 10001;
  min-width: 300px;
  
  h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1rem;
    font-weight: 600;
    color: #1f2937;
  }
  
  p {
    margin: 0 0 1rem 0;
    font-size: 0.8125rem;
    color: #6b7280;
  }
`;

const ThresholdModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10000;
`;

const ErrorMessage = styled.div`
  color: #dc2626;
  background: #fef2f2;
  border: 1px solid #fecaca;
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin-top: 1rem;
  font-size: 0.875rem;
`;

// Add CSS animation for spinner
const SpinnerStyle = styled.div`
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const CustomizationCard = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #1e40af;
    background: #f8fafc;
  }
  
  .icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f3f4f6;
    border-radius: 4px;
    margin-right: 1rem;
    font-size: 1.25rem;
    
    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }
  
  .content {
    flex: 1;
  }
  
  .title {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
  }
  
  .subtitle {
    font-size: 0.75rem;
    color: #6b7280;
    margin-bottom: 0.25rem;
  }
  
  .price {
    font-size: 0.75rem;
    font-weight: 600;
    color: #1e40af;
  }
  
  .new-badge {
    background: #1e40af;
    color: white;
    font-size: 0.625rem;
    font-weight: 600;
    padding: 0.125rem 0.375rem;
    border-radius: 2px;
    margin-left: 0.5rem;
  }
  
  .arrow {
    color: #9ca3af;
    font-size: 1.25rem;
  }
  
  @media (max-width: 768px) {
    padding: 0.75rem;
    
    .icon {
      width: 32px;
      height: 32px;
      margin-right: 0.75rem;
      font-size: 1rem;
      
      img {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }
    }
    
    .title {
      font-size: 0.75rem;
    }
    
    .subtitle {
      font-size: 0.625rem;
    }
    
    .price {
      font-size: 0.625rem;
    }
    
    .arrow {
      font-size: 1rem;
    }
  }
`;

const FontPreviewCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border: 2px solid ${props => props.$selected ? '#10b981' : '#e5e7eb'};
  border-radius: 0.5rem;
  background: ${props => props.$selected ? '#f0fdf4' : 'white'};
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  
  &:hover {
    border-color: ${props => props.$selected ? '#10b981' : '#10b981'};
    background: ${props => props.$selected ? '#f0fdf4' : '#f0fdf4'};
  }
`;

const PresetDesignsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0.75rem;
  
  @media (min-width: 769px) {
    grid-template-columns: repeat(auto-fit, minmax(125px, 1fr));
  }
`;

const PresetDesignCard = styled.div`
  padding: 0.25rem;
  border: 2px solid ${props => props.$selected ? '#10b981' : '#e5e7eb'};
  border-radius: 0.5rem;
  background: ${props => props.$selected ? '#f0fdf4' : 'white'};
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  
  &:hover {
    border-color: #10b981;
    background: #f0fdf4;
  }
`;

const FontCard = styled.div`
  padding: 1rem !important;
  border: 2px solid ${props => props.$selected ? '#10b981' : '#e5e7eb'} !important;
  border-radius: 0.5rem !important;
  background: ${props => props.$selected ? '#f0fdf4' : 'white'} !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  text-align: center !important;
  
  &:hover {
    border-color: #10b981 !important;
    background: #f0fdf4 !important;
  }
`;

const ResetButton = styled.button`
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background: #f3f4f6;
  cursor: pointer;
  color: #374151;
  transition: all 0.2s ease;
  line-height: 1;
  
  &:hover {
    background: #e5e7eb;
    border-color: #9ca3af;
  }
`;

const TermsModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  padding: 1rem;
`;

const ModerationOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10001;
  pointer-events: all;
`;

const ModerationContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
`;

const Spinner = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 1.5rem;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const TermsModalContent = styled.div`
  background: white;
  border-radius: 8px;
  max-width: 600px;
  max-height: 80vh;
  width: 100%;
  overflow-y: auto;
  position: relative;
`;

const TermsModalHeader = styled.div`
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  
  h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    text-align: center;
  }
`;

const TermsModalCloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f5f5f5;
    color: #333;
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const TermsModalBody = styled.div`
  padding: 1.5rem;
  line-height: 1.6;
  color: #555;
  position: relative;
  
  h3 {
    margin: 1.5rem 0 0.5rem 0;
    font-size: 1rem;
    font-weight: bold;
    color: #333;
    
    &:first-child {
      margin-top: 0;
    }
  }
  
  p {
    margin: 0.5rem 0;
  }
  
  ul {
    margin: 0.5rem 0;
    padding-left: 1.5rem;
  }
  
  li {
    margin: 0.25rem 0;
  }
`;

const TermsModalFooter = styled.div`
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  border-top: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  position: sticky;
  bottom:0;
  background-color: white;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const TermsCheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  
  input[type="checkbox"] {
    margin-top: 0.25rem;
    flex-shrink: 0;
  }
  
  label {
    font-size: 0.9rem;
    color: #555;
    cursor: pointer;
  }
`;

const TermsButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;

`;

const TermsButton = styled.button`
  padding: 10.4px 28px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &.cancel {
    background: #f5f5f5;
    color: #666;
    
    &:hover {
      background: #e5e5e5;
    }
  }
  
  &.accept {
    background: #007bff;
    color: white;
    
    &:hover:not(:disabled) {
      background: #0056b3;
    }
    
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
`;

// Loading Modal Styled Components
const LoadingModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
  padding: 1rem;
`;

const LoadingModalContent = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  padding: 2rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
`;

const LoadingModalHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  
  h2 {
    margin: 0 0 0.5rem 0;
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
  }
  
  p {
    margin: 0;
    font-size: 0.9rem;
    color: #666;
  }
`;

const LoadingProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

const LoadingProgressBar = styled.div`
  width: 100%;
  height: 12px;
  background: #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  
  .progress {
    height: 100%;
    background: linear-gradient(90deg, #3b82f6 0%, #10b981 100%);
    transition: width 0.3s ease;
    border-radius: 6px;
  }
`;

const LoadingPercentage = styled.div`
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  color: #3b82f6;
`;

const InstructionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f8fafc;
  border-radius: 12px;
  padding: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1rem;
  }
`;

const VideoSection = styled.div`
  flex: 1;
  width: 100%;
  margin-right: 2rem;
  
  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 1.5rem;
    max-width: 100%;
  }
`;

const InstructionsVideo = styled.video`
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const InstructionsContent = styled.div`
  flex: 1;
  max-width: 500px;
`;

const InstructionsTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 1.5rem;
  letter-spacing: 0.05em;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
    text-align: center;
  }
`;

const InstructionStep = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const StepNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: #3b82f6;
  color: white;
  border-radius: 50%;
  font-weight: bold;
  font-size: 0.875rem;
  margin-right: 1rem;
  flex-shrink: 0;
`;

const StepText = styled.p`
  color: #4b5563;
  line-height: 1.6;
  margin: 0;
  font-size: 1rem;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const SlideDrawer = styled.div`
  position: fixed;
  top: 0;
  right: ${props => props.$isOpen ? '0' : '-100%'};
  width: 500px;
  height: 100vh;
  background: white;
  border-left: 1px solid #e5e7eb;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease;
  z-index: 1000;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background 0.2s ease;
  
  &:hover {
    background: #f3f4f6;
  }
  
  @media (max-width: 768px) {
    font-size: 0.75rem;
  }
`;

const DrawerContent = styled.div`
  padding: 1.5rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  z-index: 999;
  opacity: ${props => props.$isOpen ? '1' : '0'};
  visibility: ${props => props.$isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
`;

const UploadGuidelines = styled.div`
  margin-bottom: 1rem;
`;

const GuidelinesHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  
  .icon {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
  }
  
  .title {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
  }
`;

const GuidelinesList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
`;

const GuidelineItem = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 0.75rem;
  font-size: 0.75rem;
  color: #6b7280;
  text-align: center;
  
  .icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    flex-shrink: 0;
  }
  
  .text {
    flex: 1;
    line-height: 1.4;
  }
  
  .size-requirement {
    font-weight: 600;
    color: #374151;
  }
`;

// Instructions Component
const InstructionsComponent = () => (
  <InstructionsContainer>
    <VideoSection>
      <InstructionsVideo
        autoPlay
        muted
        loop
        playsInline
        src="https://cdn.shopify.com/videos/c/o/v/1d13754fd6a14d69b9cce92863e30d3d.mp4"
      />
    </VideoSection>
    <InstructionsContent>
      <InstructionsTitle>HOW TO CUSTOMIZE:</InstructionsTitle>
      <InstructionStep>
        <StepNumber>1</StepNumber>
        <StepText>
          Pick your product – Choose from our collection of HydroJug bottles, tumblers, and accessories.
        </StepText>
      </InstructionStep>
      <InstructionStep>
        <StepNumber>2</StepNumber>
        <StepText>
          Select your color and size to see your product preview.
        </StepText>
      </InstructionStep>
      <InstructionStep>
        <StepNumber>3</StepNumber>
        <StepText>
          Add custom text, jersey designs, preset designs, or upload your own logo. Create your unique design with our customization tools.
        </StepText>
      </InstructionStep>
      <InstructionStep>
        <StepNumber>4</StepNumber>
        <StepText>
          Review your design and add to cart to complete your custom HydroJug order.
        </StepText>
      </InstructionStep>
    </InstructionsContent>
  </InstructionsContainer>
);

// Canvas Component
const ProductCanvas = ({ 
  productImageUrl, 
  customElements
}) => {
  // const stageRef = useRef();
  // const transformerRef = useRef();
  // const [productImage] = useImage(productImageUrl || '');
  const [canvasSize, setCanvasSize] = useState({ width: 600, height: 600 });
  const [isMobile, setIsMobile] = useState(false);
  const [imageSize, setImageSize] = useState({ width: 480, height: 480, x: 60, y: 60 });

  useEffect(() => {
    const updateCanvasSize = () => {
      const isMobileView = window.innerWidth <= 768;
      setIsMobile(isMobileView);
      
      if (isMobileView) {
        // Set fixed 400px size on mobile
        setCanvasSize({ width: 400, height: 400 });
      } else {
        // Use fixed 600px size on desktop
        setCanvasSize({ width: 600, height: 600 });
      }
    };

    updateCanvasSize();
    window.addEventListener('resize', updateCanvasSize);
    return () => window.removeEventListener('resize', updateCanvasSize);
  }, []);

  // Calculate image size to preserve aspect ratio - commented out for static positioning
  // useEffect(() => {
  //   if (productImage && canvasSize.width > 0) {
  //     const imgWidth = productImage.width;
  //     const imgHeight = productImage.height;
  //     const canvasWidth = canvasSize.width;
  //     const canvasHeight = canvasSize.height;
  //     
  //     // Calculate scale to fit image within canvas while preserving aspect ratio
  //     const scaleX = canvasWidth / imgWidth;
  //     const scaleY = canvasHeight / imgHeight;
  //     const scale = Math.min(scaleX, scaleY);
  //     
  //     const scaledWidth = imgWidth * scale;
  //     const scaledHeight = imgHeight * scale;
  //     
  //     // Center the image
  //     const x = (canvasWidth - scaledWidth) / 2;
  //     const onElementUpdate
  //   }
  // }, [productImage, canvasSize]);

  // useEffect(() => {
  //   if (selectedElement && transformerRef.current) {
  //     transformerRef.current.nodes([selectedElement]);
  //     transformerRef.current.getLayer().batchDraw();
  //   }
  // }, [selectedElement]);

  // const handleStageClick = (e) => {
  //   const clickedOnEmpty = e.target === e.target.getStage();
  //   if (clickedOnEmpty) {
  //     onElementSelect(null);
  //     return;
  //   }
  // };

  // const handleElementClick = (e) => {
  //   e.cancelBubble = true;
  //   onElementSelect(e.target);
  // };

  return (
    <div 
      className="customizer-canvas"
      style={{ 
        width: isMobile ? "400px" : "600px", 
        height: isMobile ? "400px" : "600px", 
        background: 'white',
        position: 'relative',
        margin: '0 auto'
      }}
    >
      {/* Conditional rendering: Instructions or Product Image */}
      {productImageUrl && (
        <img
          src={productImageUrl}
          alt="Product"
          className="customizer-product-image selectedImg"
          style={{
            position: 'absolute',
            width: "100%",
            height: "100%",
            objectFit: 'contain'
          }}
        />
      )}
      
      {/* Custom Elements - Static Positioning */}
      {customElements.map((element, index) => {
        return (
          <div key={`${index}-${element.rotation || 0}`} className={`custom-element-wrapper custom-element-${element.type}-${index}`}>
            {element.type === 'text' && (
              <div
                className={`custom-text-element custom-text-element-${index}`}
                style={{
                  position: 'absolute',
                  left: element.x,
                  top: element.y,
                  fontSize: element.fontSize,
                  fontFamily: element.fontFamily,
                  color: element.fill,
                  transformOrigin: 'center !important',
                  textAlign: 'center',
                  width: 'auto',
                  height: 'auto',
                  transform: `translate(-50%, -50%) rotate(${element.rotation || 0}deg) translateZ(0) !important`,
                  WebkitTransform: `translate(-50%, -50%) rotate(${element.rotation || 0}deg) translateZ(0) !important`,
                  willChange: 'transform'
                }}
              >
                {element.text}
              </div>
            )}
            {element.type === 'image' && (
              <img
                key={`img-${index}-${element.rotation || 0}`}
                src={element.imageUrl}
                alt="Custom Element"
                className={`custom-image-element custom-image-element-${index}`}
                style={{
                  position: 'absolute',
                  width: element.width || '150px',
                  height: element.height || '150px',
                  top: element.top || '15%',
                  left: element.left || 0,
                  right: element.right || 0,
                  margin: element.margin || '0 auto',
                  transform: `rotate(${element.rotation || 0}deg)`,
                  WebkitTransform: `rotate(${element.rotation || 0}deg)`,
                  transformOrigin: 'center',
                  objectFit: 'contain',
                  // Ultra-smooth rendering properties for perfect UI display
                  imageRendering: '-webkit-optimize-contrast',
                  WebkitImageRendering: '-webkit-optimize-contrast',
                  MozImageRendering: '-moz-crisp-edges',
                  msImageRendering: '-ms-interpolation-mode: bicubic',
                  imageSmoothing: 'high',
                  filter: 'contrast(1.05) brightness(1.02) saturate(1.1)',
                  WebkitFontSmoothing: 'antialiased',
                  MozOsxFontSmoothing: 'grayscale',
                  textRendering: 'optimizeLegibility',
                  backfaceVisibility: 'hidden', // Prevent flickering
                  WebkitBackfaceVisibility: 'hidden'
                }}
                onError={(e) => {
                  console.error('Image failed to load:', element.imageUrl, e);
                  console.error('Element details:', element);
                }}
                onLoad={() => {
                  console.log('Image loaded successfully:', element.imageUrl);
                  console.log('Image element details:', element);
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

// Custom Image Element Component - Commented out for static positioning
// const CustomImageElement = ({ element, index, onClick, onUpdate }) => {
//   const [image] = useImage(element.src || '');

//   return (
//     <KonvaImage
//       image={image}
//       x={element.x}
//       y={element.y}
//       width={element.width}
//       height={element.height}
//       rotation={element.rotation || 0}
//       onClick={onClick}
//       draggable
//       onDragEnd={(e) => {
//         onUpdate(index, {
//           ...element,
//           x: e.target.x(),
//           y: element.y()
//         });
//       }}
//       onTransformEnd={(e) => {
//         const node = e.target;
//         onUpdate(index, {
//           ...element,
//           x: node.x(),
//           y: node.y(),
//           scaleX: node.scaleX(),
//           scaleY: node.scaleY(),
//           rotation: node.rotation()
//         });
//       }}
//       className={`custom-image-element-${index}`}
//     />
//   );
// };

/**
 * Convert text into SVG paths (straight baseline or curved).
 * Returns only <path> and <g> elements, no <text>.
 */
export async function textToSVGPaths(text, fontUrl, fontSize = 100, options = {}) {
  const { x = 0, y = 0, fill = 'black', curve = null } = options;
  const font = await opentype.load(fontUrl);

  let paths = [];

  if (!curve) {
    // --- Straight baseline ---
    const path = font.getPath(text, x, y, fontSize);
    paths.push(`<path d="${path.toPathData(2)}" fill="${fill}" />`);
  } else {
    // --- Curved baseline using quadratic Bézier ---
    const { startX, startY, endX, endY, controlX, controlY } = curve;

    for (let i = 0; i < text.length; i++) {
      const t = text.length === 1 ? 0.5 : i / (text.length - 1);

      // Quadratic Bézier interpolation
      const bx = (1 - t) * (1 - t) * startX + 2 * (1 - t) * t * controlX + t * t * endX;
      const by = (1 - t) * (1 - t) * startY + 2 * (1 - t) * t * controlY + t * t * endY;

      // Tangent vector → rotation angle
      const dx = 2 * (1 - t) * (controlX - startX) + 2 * t * (endX - controlX);
      const dy = 2 * (1 - t) * (controlY - startY) + 2 * t * (endY - controlY);
      const angle = Math.atan2(dy, dx);

      // Glyph path for this character
      const glyph = font.charToGlyph(text[i]);
      const glyphPath = glyph.getPath(0, 0, fontSize);
      const d = glyphPath.toPathData(2);

      paths.push(`
        <g transform="translate(${bx}, ${by}) rotate(${(angle * 180) / Math.PI})">
          <path d="${d}" fill="${fill}" />
        </g>
      `);
    }
  }

  return paths.join('\n');
}

async function urlOrBlobToBase64(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result.split(',')[1]; // strip prefix
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}


// Main Customizer Component
function HydroCustomizer() {
  // State management
  const [collections, setCollections] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [productImageUrl, setProductImageUrl] = useState(null);
  const [customElements, setCustomElements] = useState([]);
  // const [selectedElement, setSelectedElement] = useState(null); // Commented out for static positioning
  const [customText, setCustomText] = useState("");
  const [selectedFont, setSelectedFont] = useState("Arial");


  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("text"); // text, image, design
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showModerationErrorModal, setShowModerationErrorModal] = useState(false);
  const [isModerating, setIsModerating] = useState(false);
  const [originalLogoBase64, setOriginalLogoBase64] = useState(null);



  // Cloudinary setup
  const cld = new Cloudinary({ cloud: { cloudName: 'dgepygozk' } });

  // Logo processing state
  const [logoProcessingState, setLogoProcessingState] = useState('idle'); // idle, processing, processed, error
  const [processedLogoUrl, setProcessedLogoUrl] = useState(null);
  // Removed threshold slider - using fixed threshold for better UX
  const [originalLogoUrl, setOriginalLogoUrl] = useState(null);
  const [processingProgress, setProcessingProgress] = useState(0);
  // Store the processed canvas (without metallic effect) for fast color updates
  const processedLogoCanvasRef = useRef(null);
  // Store the base canvas for preset designs (without metallic effect) for fast color updates
  const presetDesignCanvasRef = useRef(null);
  // Cache the original Image element to avoid reloading on threshold/invert changes
  const originalLogoImageRef = useRef(null);
  // Store original image dimensions for consistent quality during threshold changes
  const originalLogoDimensionsRef = useRef(null);
  // Ref for drawer element (for scroll locking)
  const drawerRef = useRef(null);
  // Cloudinary processing only happens when adding to cart
  const [processedBlob, setProcessedBlob] = useState(null);
  const [processedSize, setProcessedSize] = useState({ width: 0, height: 0 });
  const [addingToCart, setAddingToCart] = useState(false);
  const [thresholdValue, setThresholdValue] = useState(128);
  const [invertEtch, setInvertEtch] = useState(false);
  
  // Loading modal state
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const thresholdDebounceRef = useRef(null);
  
  // Review modal state (for processed logo review)
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showThresholdSlider, setShowThresholdSlider] = useState(false);
  const jerseyDebounceRef = useRef(null);
  
  // Jersey state
  const [jerseyNumber, setJerseyNumber] = useState("");
  const [jerseyText, setJerseyText] = useState("");
  const [jerseyTextPosition, setJerseyTextPosition] = useState("above"); // "above" or "below"
  const [jerseyCurveText, setJerseyCurveText] = useState(false); // Whether to curve the text
  
  // Preset designs state
  const [presetDesigns, setPresetDesigns] = useState([]);
  const [selectedPresetDesign, setSelectedPresetDesign] = useState(null);
  const [presetDesignCategories, setPresetDesignCategories] = useState([]);
  const [selectedPresetCategory, setSelectedPresetCategory] = useState(null);

  useEffect(() => {
    console.log("customElements", customElements);
  }, [customElements]);

  
  // Track last bronze etch result to avoid excessive logging
  const lastBronzeEtchResultRef = useRef(null);
  
  // Helper function to check if bronze-etch tag exists on selectedColor or selectedProduct
  const isBronzeEtch = () => {
    let result = false;
    let foundLocation = null;
    
    // Check selectedColor tags
    if (selectedColor?.tags && Array.isArray(selectedColor.tags)) {
      const hasBronze = selectedColor.tags.some(tag => tag.includes('bronze-etch'));
      if (hasBronze) {
        result = true;
        foundLocation = 'selectedColor.tags';
      }
    }
    // Check selectedColor.tags if it's a string array
    else if (selectedColor?.tags && typeof selectedColor.tags === 'string') {
      if (selectedColor.tags.includes('bronze-etch')) {
        result = true;
        foundLocation = 'selectedColor.tags (string)';
      }
    }
    // Check selectedProduct tags
    if (!result && selectedProduct?.tags && Array.isArray(selectedProduct.tags)) {
      const hasBronze = selectedProduct.tags.some(tag => tag.includes('bronze-etch'));
      if (hasBronze) {
        result = true;
        foundLocation = 'selectedProduct.tags';
      }
    }
    // Check selectedProduct.tags if it's a string array
    if (!result && selectedProduct?.tags && typeof selectedProduct.tags === 'string') {
      if (selectedProduct.tags.includes('bronze-etch')) {
        result = true;
        foundLocation = 'selectedProduct.tags (string)';
      }
    }
    // Check selectedProduct.product?.tags
    if (!result && selectedProduct?.product?.tags && Array.isArray(selectedProduct.product.tags)) {
      const hasBronze = selectedProduct.product.tags.some(tag => tag.includes('bronze-etch'));
      if (hasBronze) {
        result = true;
        foundLocation = 'selectedProduct.product.tags';
      }
    }
    
    // Only log when result changes to avoid console flooding
    if (lastBronzeEtchResultRef.current !== result) {
      if (result) {
        console.log('🔍 [Bronze Etch] Found bronze-etch tag on', foundLocation);
      } else {
        console.log('🔍 [Bronze Etch] No bronze-etch tag found. Using silver.');
      }
      lastBronzeEtchResultRef.current = result;
    }
    
    return result;
  };
  
  // Color patterns state
  const [colorPatterns, setColorPatterns] = useState({});

  // Function to get color pattern for a product
  const getColorPattern = (product) => {
    if (!product || !colorPatterns) return null;
    
    // Extract color name from product title (normalize to lowercase)
    const productTitle = product.title?.toLowerCase() || '';
    
    // Sort patterns by label length (longest first) to prioritize more specific matches
    const sortedPatterns = Object.entries(colorPatterns)
      .filter(([handle, pattern]) => pattern.label)
      .sort(([, a], [, b]) => b.label.length - a.label.length);
    
    // Look for matching color pattern using the label field for exact matching
    for (const [handle, pattern] of sortedPatterns) {
      const patternLabel = pattern.label.toLowerCase();
      
      // Check if the product title contains the exact label
      if (productTitle.includes(patternLabel)) {
        return pattern;
      }
    }
    
    return null;
  };

  // Fonts available
  const fonts = [
    // { name: "Arial", value: "Arial" },
    { name: "Times New Roman", value: "Times New Roman" },
    // { name: "Verdana", value: "Verdana" },
    // { name: "Impact", value: "Impact" },
    // { name: "Cursive", value: "Snell Roundhand" },
    // { name: "Lemon Jelly", value: "lemon jelly personal use" },
    // { name: "Comic Sans", value: "Comic Sans MS" },
    // { name: "Lovely Coffee", value: "lovely coffee" },
    { name: "Freshman", value: "Freshman" },
    { name: "Montserrat", value: "Montserrat" },
    // { name: "Litoland Regular", value: "Litoland_Regular" },
    // { name: "Steelfish Bd", value: "Steelfish_Bd" },
    // { name: "Magnolia Script", value: "Magnolia_Script" },
    // Adobe Typekit fonts
    { name: "Soap", value: "soap" },
    // { name: "Fisterra Fora", value: "fisterra-fora" },
    { name: "Fisterra", value: "fisterra-morte" },
    // { name: "Sloop Script One", value: "sloop-script-one" },
    // { name: "Sloop Script Pro", value: "sloop-script-pro" },
    { name: "Sloop Script", value: "sloop-script-two" },
    // { name: "Sloop Script Three", value: "sloop-script-three" },
  ];

  // Prevent navigation/refresh during moderation
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isModerating) {
        e.preventDefault();
        e.returnValue = 'Image moderation is in progress. Are you sure you want to leave?';
        return e.returnValue;
      }
    };

    const handlePopState = (e) => {
      if (isModerating) {
        e.preventDefault();
        window.history.pushState(null, '', window.location.href);
        alert('Please wait for image moderation to complete before navigating away.');
      }
    };

    if (isModerating) {
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('beforeunload', handleBeforeUnload);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isModerating]);

  // Lock body scroll when drawer or review modal is open
  useEffect(() => {
    const shouldLock = isDrawerOpen || showReviewModal;
    
    if (shouldLock) {
      // Add class to lock body scroll
      document.documentElement.classList.add('customizer-scroll-lock');
      document.body.classList.add('customizer-scroll-lock');
    } else {
      // Remove all scroll lock classes
      document.documentElement.classList.remove('customizer-scroll-lock');
      document.body.classList.remove('customizer-scroll-lock');
      document.documentElement.classList.remove('ps-scroll-lock');
      document.body.classList.remove('ps-scroll-lock');
    }
    
    // Cleanup on unmount
    return () => {
      document.documentElement.classList.remove('customizer-scroll-lock');
      document.body.classList.remove('customizer-scroll-lock');
      document.documentElement.classList.remove('ps-scroll-lock');
      document.body.classList.remove('ps-scroll-lock');
    };
  }, [isDrawerOpen, showReviewModal]);

  // Fetch products on component mount
  useEffect(() => {
    const initializeData = async () => {
      const patterns = await fetchColorPatterns();
      setColorPatterns(patterns);
      fetchProducts();
      await fetchPresetDesigns();
    };
    
    initializeData();
  }, []);

  // Parse URL query parameter to auto-select product type
  useEffect(() => {
    // Only run if collections are loaded and no product is selected yet
    if (collections.length === 0 || selectedProduct) return;

    // Parse URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const defaultProductType = urlParams.get('default');

    if (defaultProductType) {
      // Find the collection with matching handle
      const matchingCollection = collections.find(
        collection => collection.handle === defaultProductType
      );

      if (matchingCollection && matchingCollection.products.length > 0) {
        // Select the first product from the matching collection
        const newProduct = {
          ...matchingCollection.products[0],
          collectionHandle: matchingCollection.handle,
          allProducts: matchingCollection.products
        };
        
        setSelectedProduct(newProduct);
        
        // Select the first available color
        if (newProduct.allProducts.length > 0) {
          setSelectedColor(newProduct.allProducts[0]);
        }
        
        console.log(`✅ Auto-selected product type from URL: ${defaultProductType}`);
      } else {
        console.warn(`⚠️ No collection found with handle: ${defaultProductType}`);
      }
    }
  }, [collections, selectedProduct]);

  // Update product image when product/color changes
  useEffect(() => {
    if (selectedColor) {
      // Find the customizer image for the selected product
      const customizerImage = selectedColor.images.find(img => 
        img.alt && img.alt.toLowerCase().includes('customizer')
      );
      
      if (customizerImage?.src) {
        setProductImageUrl(customizerImage.src);
      } else if (selectedColor.images[0]?.src) {
        // Fallback to first image if no customizer image found
        setProductImageUrl(selectedColor.images[0].src);
      }
    }
  }, [selectedColor]);

  // Track last processed color to prevent infinite loops
  const lastProcessedColorRef = useRef(null);
  
  // Reset ref when customElements becomes empty
  useEffect(() => {
    if (customElements.length === 0) {
      lastProcessedColorRef.current = null;
      processedLogoCanvasRef.current = null;
    }
  }, [customElements.length]);
  
  // Fast update metallic effect for uploaded logos when color/product changes
  useEffect(() => {
    if (processedLogoCanvasRef.current && processedBlob && originalLogoUrl && customElements.length > 0) {
      const element = customElements[0];
      // Only update if it's an uploaded logo (not preset, not text, not jersey)
      if (element.type === 'image' && !element.isPresetDesign && !element.text && !(jerseyNumber || jerseyText)) {
        console.log('⚡ Fast updating logo metallic effect for color/product change...');
        try {
          const updatedCanvas = updateMetallicEffect(processedLogoCanvasRef.current);
          if (updatedCanvas) {
            // Convert to SVG for display
            const svgString = canvasToSVG(updatedCanvas, updatedCanvas.width, updatedCanvas.height);
            const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
            const displayUrl = URL.createObjectURL(svgBlob);
            
            // Update the processed logo URL
            if (processedLogoUrl) {
              URL.revokeObjectURL(processedLogoUrl);
            }
            setProcessedLogoUrl(displayUrl);
            
            // Update the custom element with new URL
            setCustomElements(prev => 
              prev.map(el => ({
                ...el,
                imageUrl: displayUrl
              }))
            );
          }
        } catch (error) {
          console.error('Error fast updating logo metallic effect:', error);
        }
      }
    }
  }, [selectedColor?.id, selectedColor?.title, selectedProduct?.id, selectedProduct?.handle]);
  
  // Regenerate custom elements when color changes to update etch color
  useEffect(() => {
    const regenerateDesignsForColor = async () => {
      if (!selectedColor || customElements.length === 0) {
        lastProcessedColorRef.current = null;
        return;
      }
      
      // Prevent infinite loop: only regenerate if color actually changed
      const currentColorId = selectedColor.id || selectedColor.title;
      if (lastProcessedColorRef.current === currentColorId) {
        console.log('⏭️ Skipping regeneration - color already processed:', currentColorId);
        return;
      }
      
      // Skip fast update for uploaded logos - handled by separate useEffect
      if (processedLogoCanvasRef.current && processedBlob && originalLogoUrl) {
        const element = customElements[0];
        if (element.type === 'image' && !element.isPresetDesign && !element.text && !(jerseyNumber || jerseyText)) {
          console.log('⏭️ Skipping slow regeneration - using fast update for uploaded logo');
          return;
        }
      }
      
      console.log('🔄 Starting regeneration for color:', currentColorId);
      lastProcessedColorRef.current = currentColorId;
      
      const element = customElements[0];
      
      // Only regenerate if it's a preset design or text element
      if (element.isPresetDesign && selectedPresetDesign) {
        console.log('🔄 Fast updating preset design for new color...');
        try {
          // Use fast update if base canvas is cached
          if (presetDesignCanvasRef.current) {
            // Use fast mode for UI updates (lower resolution, faster processing)
            const updatedCanvas = updateMetallicEffect(presetDesignCanvasRef.current, { fastMode: true });
            if (updatedCanvas) {
              // Use data URL directly - much faster than blob
              const metallicUrl = updatedCanvas.toDataURL('image/png');
              setCustomElements(prev => 
                prev.map(el => ({
                  ...el,
                  imageUrl: metallicUrl
                }))
              );
            }
          } else {
            // Fallback to full reprocess if base canvas not available
            const originalImageUrl = selectedPresetDesign.image?.src || selectedPresetDesign.image?.url;
            if (originalImageUrl) {
              const metallicImageUrl = await processPresetDesignWithMetallic(originalImageUrl, { storeBaseCanvas: true });
              
              setCustomElements(prev => 
                prev.map(el => ({
                  ...el,
                  imageUrl: metallicImageUrl
                }))
              );
            }
          }
        } catch (error) {
          console.error('Error regenerating design for color:', error);
        }
      } else if (element.type === 'image' && customText) {
        // Regenerate metallic text for the new color
        console.log('🔄 Regenerating text for new color...');
        const canvasWidth = window.innerWidth <= 768 ? 400 : 600;
        const canvasHeight = window.innerWidth <= 768 ? 400 : 600;
        
        try {
          // Use the existing createMetallicText function
          await new Promise((resolve) => {
            createMetallicText(element.text || customText, element.fontFamily || selectedFont, canvasWidth, canvasHeight);
            setTimeout(resolve, 100); // Give it time to process
          });
        } catch (error) {
          console.error('Error regenerating text for color:', error);
        }
      } else if (element.type === 'image' && (jerseyNumber || jerseyText)) {
        // Regenerate jersey for the new color
        console.log('🔄 Regenerating jersey for new color...');
        try {
          const canvasWidth = window.innerWidth <= 768 ? 400 : 600;
          const canvasHeight = window.innerWidth <= 768 ? 400 : 600;
          await createJerseyDesign(jerseyNumber, jerseyText, jerseyTextPosition, canvasWidth, canvasHeight);
        } catch (error) {
          console.error('Error regenerating jersey for color:', error);
        }
      }
      // Note: Uploaded logos are now handled by the fast update useEffect above
    };
    
    regenerateDesignsForColor();
  }, [selectedColor?.id, selectedColor?.title]); // Only depend on color identity, not the whole object

  // Update custom elements positioning when product type changes
  useEffect(() => {
    if (customElements.length > 0 && selectedProduct) {
      const productType = selectedProduct.collectionHandle || 'traveler-40oz';
      
      setCustomElements(prevElements => 
        prevElements.map(element => {
          if (element.type === 'image') {
            // Determine element type based on how it was created
            const elementType = element.isPresetDesign ? 'design' : 'text';
            const textLength = element.textLength || 0;
            const styles = getCustomElementStyles(productType, elementType, textLength);
            
            return {
              ...element,
              width: styles.width,
              height: styles.height,
              top: styles.top,
              left: styles.left,
              right: styles.right,
              margin: styles.margin
            };
          }
          return element;
        })
      );
    }
  }, [selectedProduct]);

  const fetchColorPatterns = async () => {
    try {
      const query = `
        query getColorPatterns {
          metaobjects(type: "shopify--color-pattern", first: 200) {
            nodes {
              handle
              fields {
                value
                key
                reference {
                  ... on MediaImage {
                    image {
                      altText
                      url
                    }
                  }
                }
              }
            }
          }
        }
      `;

      const response = await fetch('/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '98883f501bb8ee09f85caaeca8d1dd02'
        },
        body: JSON.stringify({ query })
      });

      const result = await response.json();
      if (result.errors) {
        throw new Error('GraphQL Error: ' + JSON.stringify(result.errors));
      }

      
      // Process metaobjects into a lookup map
      const colorPatterns = {};
      result.data.metaobjects.nodes.forEach(node => {
        const pattern = { handle: node.handle };
        node.fields.forEach(field => {
          if (field.key === 'image' && field.reference?.image) {
            // Handle MediaImage reference
            pattern[field.key] = field.reference.image.url;
            pattern[`${field.key}_alt`] = field.reference.image.altText;
          } else {
            // Handle regular value fields (like color hex codes)
            pattern[field.key] = field.value;
          }
        });
        colorPatterns[node.handle] = pattern;
      });

      return colorPatterns;
    } catch (error) {
      console.error('Error fetching color patterns:', error);
      return {};
    }
  };

  const fetchProducts = async () => {
    console.log('🔄 Starting to fetch products from collections...');
    setLoading(true);
    const collectionHandles = [
      "traveler-40oz", "traveler-32oz", "traveler-20oz", "coffee-travelers",
      "sport-40oz", "sport-32oz", "sport-20oz", "sport-14oz", 
      "can-cooler-16oz", "everyday-tumbler-14oz", "everyday-tumbler-20oz",
      "stainless-64oz", "can-coolers-slim", "can-coolers-standard",
      "insulated-shaker", 
    ];

    try {
      for (let handle of collectionHandles) {
          console.log(`📦 Fetching collection: ${handle}`);
          const query = `
            query getCollection($handle: String!) {
              collectionByHandle(handle: $handle) {
                id
                handle
                title
                products(first: 150) {
                  nodes {
                    id
                    title
                    handle
                    onlineStoreUrl
                    totalInventory
                  productType
                    tags
                    images(first: 10) {
                      nodes {
                        url
                        altText
                      }
                    }
                    variants(first: 10) {
                      nodes {
                        id
                        title
                        price {
                          amount
                        }
                        availableForSale
                        image {
                          url
                          altText
                        }
                      }
                    }
                  }
                }
              }
            }
          `;

          const response = await fetch('/api/2024-01/graphql.json', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': '98883f501bb8ee09f85caaeca8d1dd02'
            },
            body: JSON.stringify({
              query,
              variables: { handle }
            })
          });

          if (!response.ok) {
            console.error(`❌ GraphQL request failed for ${handle}:`, response.status, response.statusText);
            const errorText = await response.text();
            console.error('Error response:', errorText);
            continue; // Skip this collection and continue with others
          }

          const result = await response.json();
          
          if (result.errors) {
            console.error(`❌ GraphQL errors for ${handle}:`, result.errors);
            continue; // Skip this collection and continue with others
          }
          
          if (!result.data?.collectionByHandle) {
            console.warn(`⚠️ Collection not found: ${handle}`);
            continue; // Skip this collection
          }

          const collection = {
            handle: result.data.collectionByHandle.handle,
            title: result.data.collectionByHandle.title,
            products: result.data.collectionByHandle.products.nodes
              .filter(p => p.totalInventory > 0 && p.onlineStoreUrl)
              .map(product => ({
                id: product.id,
                title: product.title,
                handle: product.handle,
                images: product.images.nodes.map(img => ({ src: img.url, alt: img.altText })),
              productType: product.productType,
                tags: product.tags,
                variants: product.variants.nodes
                  .filter(variant => variant.availableForSale)
                  .map(variant => ({
                    id: variant.id.replace(/^gid:\/\/shopify\/ProductVariant\//, ""),
                    title: variant.title,
                    price: variant.price.amount,
                    available: variant.availableForSale,
                    featured_image: variant.image ? { src: variant.image.url } : null
                  }))
              }))
              .filter(p => p.variants.length > 0)
          };

          console.log(`✅ Successfully fetched ${collection.products.length} products from ${handle}`);
          setCollections(prev => [...prev, collection]);
      }
      
      console.log('✅ Finished fetching all collections');
    } catch (err) {
      console.error("❌ Product fetch error:", err);
    }
    setLoading(false);
  };

    // Fetch preset designs from metaobject
  const fetchPresetDesigns = async () => {
    try {
      const query = `
        query getEtchesMetaobject {
          metaobjects(type: "etches", first: 1) {
            nodes {
              handle
              fields {
                key
                value
                references(first: 50) {
                  nodes {
                    ... on MediaImage {
                      image {
                        altText
                        url
                      }
                    }
                    ... on Metaobject {
                      __typename
                      handle
                      fields {
                        key
                        value
                        reference {
                          ... on MediaImage {
                            image {
                              altText
                              url
                            }
                          }
                        }
                      }
                    }
                  }
                }
                reference {
                  ... on MediaImage {
                    image {
                      altText
                      url
                    }
                  }
                  ... on Metaobject {
                    __typename
                    handle
                    fields {
                      key
                      value
                      reference {
                        ... on MediaImage {
                          image {
                            altText
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      const response = await fetch('/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '98883f501bb8ee09f85caaeca8d1dd02'
        },
        body: JSON.stringify({ query })
      });

      const result = await response.json();
      
      if (result.errors) {
        console.error('❌ [Preset Designs] GraphQL errors:', result.errors);
        throw new Error('GraphQL Error: ' + JSON.stringify(result.errors));
      }

      if (!result.data) {
        console.error('❌ [Preset Designs] No data in response');
        return;
      }

      if (!result.data.metaobjects) {
        console.error('❌ [Preset Designs] No metaobjects in data');
        return;
      }


      // Process metaobject fields into categories
      const categories = {};
      
      if (result.data.metaobjects.nodes.length > 0) {
        const etchesMetaobject = result.data.metaobjects.nodes[0];
        
        etchesMetaobject.fields.forEach((field, fieldIndex) => {
          // Each field represents a category of designs
          const categoryName = field.key;
          
          if (!categories[categoryName]) {
            categories[categoryName] = [];
          }
          
          // Handle multiple references (lists of metaobjects or images)
          if (field.references && field.references.nodes) {
            field.references.nodes.forEach((ref, index) => {
              
              let imageUrl = null;
              let altText = null;
              let etchName = null;
              
              // Handle Metaobject references (nested structure)
              // Check for handle and fields properties (__typename may not be available)
              if ((ref.__typename === 'Metaobject' || (ref.handle && ref.fields)) && ref.fields) {
                ref.fields.forEach(metaField => {
                  const fieldKey = metaField.key.toLowerCase();
                  
                  // Extract Etch Name
                  if (fieldKey === 'etch_name' || fieldKey === 'etch name') {
                    etchName = metaField.value;
                  }
                  
                  // Extract Etch Image (MediaImage reference)
                  if ((fieldKey === 'etch_image' || fieldKey === 'etch image') && metaField.reference) {
                    if (metaField.reference.image) {
                      imageUrl = metaField.reference.image.url;
                      altText = metaField.reference.image.altText;
                    }
                  }
                });
                
                // Use etch name as title, fallback to altText
                const title = etchName || altText || `${categoryName} Design ${index + 1}`;
                
                if (imageUrl) {
                  const design = {
                    id: `${categoryName}-${index}`,
                    title: title,
                    handle: categoryName.toLowerCase().replace(/\s+/g, '-'),
                    image: { src: imageUrl, alt: altText || etchName },
                    price: '6.00',
                    variantId: null,
                    productId: null
                  };
                  categories[categoryName].push(design);
                }
              }
              // Handle direct MediaImage references (fallback for old structure)
              else if (ref.image) {
                imageUrl = ref.image.url;
                altText = ref.image.altText;
                
                const design = {
                  id: `${categoryName}-${index}`,
                  title: altText || `${categoryName} Design ${index + 1}`,
                  handle: categoryName.toLowerCase().replace(/\s+/g, '-'),
                  image: { src: imageUrl, alt: altText },
                  price: '6.00',
                  variantId: null,
                  productId: null
                };
                categories[categoryName].push(design);
              }
            });
          }
          // Handle single reference (fallback)
          else if (field.reference) {
            
            let imageUrl = null;
            let altText = null;
            let etchName = null;
            
            // Handle Metaobject reference (nested structure)
            // Check for handle and fields properties (__typename may not be available)
            if ((field.reference.__typename === 'Metaobject' || (field.reference.handle && field.reference.fields)) && field.reference.fields) {
              field.reference.fields.forEach(metaField => {
                const fieldKey = metaField.key.toLowerCase();
                
                // Extract Etch Name
                if (fieldKey === 'etch_name' || fieldKey === 'etch name') {
                  etchName = metaField.value;
                }
                
                // Extract Etch Image (MediaImage reference)
                if ((fieldKey === 'etch_image' || fieldKey === 'etch image') && metaField.reference) {
                  if (metaField.reference.image) {
                    imageUrl = metaField.reference.image.url;
                    altText = metaField.reference.image.altText;
                  }
                }
              });
              
              // Use etch name as title, fallback to altText
              const title = etchName || altText || `${categoryName} Design 1`;
              
              if (imageUrl) {
                const design = {
                  id: `${categoryName}-0`,
                  title: title,
                  handle: categoryName.toLowerCase().replace(/\s+/g, '-'),
                  image: { src: imageUrl, alt: altText || etchName },
                  price: '6.00',
                  variantId: null,
                  productId: null
                };
                categories[categoryName].push(design);
              }
            }
            // Handle direct MediaImage reference (fallback for old structure)
            else if (field.reference.image) {
              imageUrl = field.reference.image.url;
              altText = field.reference.image.altText;
              
              const design = {
                id: `${categoryName}-0`,
                title: altText || `${categoryName} Design 1`,
                handle: categoryName.toLowerCase().replace(/\s+/g, '-'),
                image: { src: imageUrl, alt: altText },
                price: '6.00',
                variantId: null,
                productId: null
              };
              categories[categoryName].push(design);
            } 
          }
        });
      } else {
        console.warn('⚠️ [Preset Designs] No metaobjects found');
      }
      
      
      // Convert categories object to array format
      const categoriesArray = Object.keys(categories).map(categoryName => ({
        name: categoryName,
        designs: categories[categoryName]
      }));
      
      setPresetDesignCategories(categoriesArray);
      setPresetDesigns(categoriesArray);
    } catch (error) {
      console.error('❌ [Preset Designs] Error fetching preset designs from metaobject:', error);
      console.error('❌ [Preset Designs] Error stack:', error.stack);
    }
  };

  // Logo processing function - local preview only, no Cloudinary upload
  const processLogoForEtching = async (file) => {
    if (!file) return;

    // Clear any cached image before processing new one
    originalLogoImageRef.current = null;
    originalLogoDimensionsRef.current = null;
    processedLogoCanvasRef.current = null;
    
    setLogoProcessingState('processing');
    setProcessingProgress(0);
    const localUrl = URL.createObjectURL(file);
    setOriginalLogoUrl(localUrl);

    try {
      setProcessingProgress(40);
      // Only do local processing for UI preview - no Cloudinary upload yet
      // Use preview: true for consistent sizing with slider/invert updates
      await processImageLocally(localUrl, { thresholdValue, invert: invertEtch, keepDrawerOpen: true, preview: true });
      setProcessingProgress(100);
      return;
    } catch (error) {
      console.error("Local etch processing error:", error);
      setLogoProcessingState('error');
      setProcessingProgress(0);
    }
  };

  // Add processed logo to canvas
  const addProcessedLogoToCanvas = (logoUrl, { keepDrawerOpen = false, preserveTransform = false } = {}) => {
    
    // Clear all other style states when adding logo
    setSelectedPresetDesign(null);
    // Clear text states
    setCustomText('');
    // Clear jersey states
    setJerseyNumber('');
    setJerseyText('');
    setJerseyTextPosition('below');
    
    const img = new Image();
    img.onload = () => {
      
      // Get dynamic styles based on selected product
      const productType = selectedProduct?.collectionHandle || 'traveler-40oz';
      const styles = getCustomElementStyles(productType, 'design');

      // If we already have an element and want to preserve its transform, reuse it
      const existing = customElements && customElements.length > 0 ? customElements[0] : null;
      if (preserveTransform && existing && existing.type === 'image') {
        const newElement = {
          ...existing,
          imageUrl: logoUrl
        };
        setCustomElements([newElement]);
      } else {
        // Use dynamic styles for positioning and sizing
      const newElement = {
        type: 'image',
          imageUrl: logoUrl,
          width: styles.width,
          height: styles.height,
          top: styles.top,
          left: styles.left,
          right: styles.right,
          margin: styles.margin,
          rotation: existing?.rotation || 0,
          isPresetDesign: false,
          textLength: 0
        };

      setCustomElements([newElement]);
      }
      
      if (!keepDrawerOpen) setIsDrawerOpen(false);
    };
    
    img.onerror = (error) => {
      console.error("Error loading processed image:", error);
    };
    
    img.src = logoUrl;
  };



  // Threshold is now fixed for optimal results

  // Function to render image at higher resolution for smoother edges
  const renderHighRes = (img, targetWidth, targetHeight, threshold, invert = false, rotation = 0, highResScale = 4) => {
    // Use configurable resolution scale (default 4x for final, 1x for preview)
    const scale = highResScale;
    
    // Calculate rotated dimensions if needed
    let canvasWidth = targetWidth;
    let canvasHeight = targetHeight;
    
    if (rotation !== 0) {
      // Calculate the bounding box for the rotated image
      const radians = (rotation * Math.PI) / 180;
      const cos = Math.abs(Math.cos(radians));
      const sin = Math.abs(Math.sin(radians));
      
      canvasWidth = Math.ceil(targetWidth * cos + targetHeight * sin);
      canvasHeight = Math.ceil(targetWidth * sin + targetHeight * cos);
    }
    
    const highResWidth = canvasWidth * scale;
    const highResHeight = canvasHeight * scale;
    const imgHighResWidth = targetWidth * scale;
    const imgHighResHeight = targetHeight * scale;
    
    // Create high-resolution canvas
    const highResCanvas = document.createElement('canvas');
    const highResCtx = highResCanvas.getContext('2d');
    highResCanvas.width = highResWidth;
    highResCanvas.height = highResHeight;
    
    // Enable high-quality rendering
    highResCtx.imageSmoothingEnabled = true;
    highResCtx.imageSmoothingQuality = 'high';
    
    // Apply rotation if specified
    if (rotation !== 0) {
      // Move to center of canvas, rotate, then draw image centered
      highResCtx.translate(highResWidth / 2, highResHeight / 2);
      highResCtx.rotate((rotation * Math.PI) / 180);
      highResCtx.drawImage(img, -imgHighResWidth / 2, -imgHighResHeight / 2, imgHighResWidth, imgHighResHeight);
      // Reset transform for image processing
      highResCtx.setTransform(1, 0, 0, 1, 0, 0);
    } else {
      // Draw image at high resolution without rotation
      highResCtx.drawImage(img, 0, 0, highResWidth, highResHeight);
    }
    
    // Process at high resolution
    const imageData = highResCtx.getImageData(0, 0, highResWidth, highResHeight);
    const data = imageData.data;
    
    // ============================================================
    // SIMPLE GRAYSCALE CONVERSION FOR UI PREVIEW
    // ============================================================
    // The backend applies complex preprocessing (median, normalize, sharpen)
    // that's hard to match exactly. Instead of trying to replicate it,
    // we use simple grayscale for the UI preview.
    // 
    // The threshold slider lets users adjust until the preview looks right,
    // and that same threshold is sent to the backend which applies its own
    // preprocessing. The key insight is that the USER adjusts the slider
    // until the UI looks correct - we just need to ensure the backend
    // produces the same visual result for that threshold value.
    //
    // To achieve this, we REMOVE preprocessing from the backend threshold
    // and apply it BEFORE the threshold step, OR we match preprocessing here.
    // For now, we use simple grayscale which is more predictable.
    // ============================================================
    
    // Convert to grayscale using Rec. 709 luminosity formula (same as Sharp/libvips)
    // This ensures the threshold produces the same result as the backend
    const grayscaleData = new Uint8ClampedArray(highResWidth * highResHeight);
    for (let i = 0, j = 0; i < data.length; i += 4, j++) {
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];
      const a = data[i + 3];
      
      if (a > 0) {
        // Rec. 709 luminosity formula (same as Sharp's grayscale)
        grayscaleData[j] = Math.round(0.2126 * r + 0.7152 * g + 0.0722 * b);
      } else {
        // Transparent becomes white (background)
        grayscaleData[j] = 255;
      }
    }
    
    // Use grayscale directly for thresholding (no additional preprocessing)
    // This ensures the UI preview matches what the user expects from the slider
    const sharpened = grayscaleData;
        
    // First pass: detect background color by sampling corners and edges
    const samplePoints = [];
    const sampleSize = Math.min(highResWidth, highResHeight) * 0.1; // 10% of smaller dimension
    
    // Sample corners
    for (let x = 0; x < sampleSize; x += 2) {
      for (let y = 0; y < sampleSize; y += 2) {
        samplePoints.push({ x, y });
        samplePoints.push({ x: highResWidth - 1 - x, y });
        samplePoints.push({ x, y: highResHeight - 1 - y });
        samplePoints.push({ x: highResWidth - 1 - x, y: highResHeight - 1 - y });
      }
    }
    
    // Calculate average background grayscale from preprocessed data
    let bgGray = 0, bgCount = 0;
    samplePoints.forEach(point => {
      const idx = point.y * highResWidth + point.x;
      const rgbaIdx = (point.y * highResWidth + point.x) * 4;
      const a = data[rgbaIdx + 3];
      
      if (a > 0) {
        bgGray += sharpened[idx];
        bgCount++;
      }
    });
    
    const avgBgGray = bgCount > 0 ? bgGray / bgCount : 255;
    const bgThreshold = 20; // How close to background grayscale to consider as background
        
    for (let i = 0, p = 0; i < data.length; i += 4, p++) {
      const a = data[i + 3];
      
      // Use preprocessed grayscale value (matches backend processing)
      const gray = sharpened[p];
          
      // Check if this pixel is background color (based on preprocessed grayscale)
      const isBackground = a > 10 && Math.abs(gray - avgBgGray) < bgThreshold;
          
      // Check if this pixel has content based on threshold level
      const shouldEtch = a > 10 && gray < threshold && !isBackground;
      
      if (invert) {
        // Inverted logic: etch what was solid, make solid what was etched
        if (a > 10 && !isBackground) {
          if (shouldEtch) {
            // This was going to be etched, make it solid (transparent background)
            data[i + 3] = 0;
          } else {
            // This was going to be solid, make it etched (metallic)
            const x = (p % highResWidth) / highResWidth;
            const y = Math.floor(p / highResWidth) / highResHeight;
            
            // Create metallic silver with directional sheen
            const t = (Math.sin(x * Math.PI * 2) * 0.5 + 0.5) * 0.8 + 0.1;
            const metallicR = Math.round(130 * (1 - t) + 248 * t);
            const metallicG = Math.round(135 * (1 - t) + 249 * t);
            const metallicB = Math.round(140 * (1 - t) + 252 * t);
            
            data[i] = metallicR;
            data[i + 1] = metallicG;
            data[i + 2] = metallicB;
            data[i + 3] = 255; // Keep fully opaque
          }
        } else {
          // Background areas and transparent areas stay transparent
          data[i + 3] = 0;
        }
      } else {
        // Normal logic: etch dark areas, make light areas and background transparent
        if (shouldEtch) {
            // Calculate position for metallic effect
          const x = (p % highResWidth) / highResWidth;
          const y = Math.floor(p / highResWidth) / highResHeight;
            
            // Create metallic silver with directional sheen
            const t = (Math.sin(x * Math.PI * 2) * 0.5 + 0.5) * 0.8 + 0.1;
            const metallicR = Math.round(130 * (1 - t) + 248 * t);
            const metallicG = Math.round(135 * (1 - t) + 249 * t);
            const metallicB = Math.round(140 * (1 - t) + 252 * t);
            
            data[i] = metallicR;
            data[i + 1] = metallicG;
            data[i + 2] = metallicB;
            data[i + 3] = 255; // Keep fully opaque
          } else {
          // Make background and light areas transparent
            data[i + 3] = 0;
          }
        }
        
      // Additional background removal: make very light areas transparent regardless of invert setting
      // This helps remove white/light backgrounds that might not be caught by the threshold
      if (a > 10 && gray > 240) {
        data[i + 3] = 0; // Make very light areas transparent
      }
    }
    
    // Put the processed high-res data back
    highResCtx.putImageData(imageData, 0, 0);
    
    // Create final canvas at correct resolution (accounting for rotation)
    const finalCanvas = document.createElement('canvas');
    const finalCtx = finalCanvas.getContext('2d');
    finalCanvas.width = canvasWidth;
    finalCanvas.height = canvasHeight;
    
    // Enable high-quality downsampling
    finalCtx.imageSmoothingEnabled = true;
    finalCtx.imageSmoothingQuality = 'high';
    
    // Downsample the high-res image to final resolution
    finalCtx.drawImage(highResCanvas, 0, 0, canvasWidth, canvasHeight);
    
    return finalCanvas;
  };

  // Fast function to update metallic effect on stored base canvas
  const updateMetallicEffect = (baseCanvas, options = {}) => {
    if (!baseCanvas) return null;
    
    const { fastMode = false } = options;
    
    // For fast UI updates, downsample to 1x resolution first
    let canvas, ctx;
    if (fastMode && baseCanvas.width > 1000) {
      // Downsample to reasonable size for UI (max 1000px)
      const maxSize = 1000;
      const scale = Math.min(maxSize / baseCanvas.width, maxSize / baseCanvas.height);
      canvas = document.createElement('canvas');
      canvas.width = Math.floor(baseCanvas.width * scale);
      canvas.height = Math.floor(baseCanvas.height * scale);
      ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(baseCanvas, 0, 0, canvas.width, canvas.height);
    } else {
      // Use full resolution
      canvas = document.createElement('canvas');
      canvas.width = baseCanvas.width;
      canvas.height = baseCanvas.height;
      ctx = canvas.getContext('2d');
      ctx.drawImage(baseCanvas, 0, 0);
    }
    
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    
    // Check if selected jug has bronze-etch tag
    const isBronzeEtchValue = isBronzeEtch();
    
    // Process all pixels
    for (let i = 0; i < data.length; i += 4) {
      const a = data[i + 3];
      if (a > 0) {
        // Calculate position for metallic effect
        const x = ((i / 4) % canvas.width) / canvas.width;
        
        // Create metallic effect - bronze or silver based on jug tag
        const distanceFromCenter = Math.abs(x - 0.5) * 2;
        const t = (1 - distanceFromCenter) * 0.8 + 0.1;
        
        let metallicR, metallicG, metallicB;
        if (isBronzeEtchValue) {
          const bronzeBase = { r: 155, g: 120, b: 85 };
          const bronzeHighlight = { r: 230, g: 190, b: 130 };
          metallicR = Math.round(bronzeBase.r * (1 - t) + bronzeHighlight.r * t);
          metallicG = Math.round(bronzeBase.g * (1 - t) + bronzeHighlight.g * t);
          metallicB = Math.round(bronzeBase.b * (1 - t) + bronzeHighlight.b * t);
        } else {
          metallicR = Math.round(130 * (1 - t) + 248 * t);
          metallicG = Math.round(135 * (1 - t) + 249 * t);
          metallicB = Math.round(140 * (1 - t) + 252 * t);
        }
        
        data[i] = metallicR;
        data[i + 1] = metallicG;
        data[i + 2] = metallicB;
      }
    }
    
    ctx.putImageData(imageData, 0, 0);
    return canvas;
  };

  // Function to convert processed canvas to SVG using a simpler approach
  const canvasToSVG = (canvas, width, height) => {
    // Convert the processed canvas to a data URL
    const dataURL = canvas.toDataURL('image/png');
    
    // Create SVG with the processed image embedded
    // This preserves the exact appearance without trying to trace paths
    const svg = `
      <svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,0 L0.001,0.001" />
        <path d="M${width},${height} L${width}.001,${height}.001" />
        <image href="${dataURL}" width="${width}" height="${height}" />
      </svg>
    `;
    
    return svg;
  };


  // Simple logo processing - just make it metallic
  const processImageLocally = async (imageUrl, options = {}) => {
    const { keepDrawerOpen = false, preserveTransform = false, preview = false, thresholdValue, forUpload = false, invert = false, skipModal = false } = options;
    console.log("processImageLocally called with options:", options, "thresholdValue:", thresholdValue, "forUpload:", forUpload, "invert:", invert, "skipModal:", skipModal);
    const scale = preview ? 0.4 : 1; // Use 0.4 scale for preview (balanced size + quality)
    
    return new Promise((resolve, reject) => {
      try {
        setProcessingProgress(60);
        
        // Use cached Image element if available (for threshold/invert changes), otherwise load from URL
        let img = originalLogoImageRef.current;
        
        if (img && img.complete && img.naturalWidth > 0) {
          // Image is already loaded, process immediately
          processImageDirectly();
        } else {
          // Need to load the image
          img = new Image();
          img.crossOrigin = 'anonymous';
          
          img.onload = () => {
            // Cache the image for future threshold/invert changes
            if (!originalLogoImageRef.current) {
              originalLogoImageRef.current = img;
            }
            processImageDirectly();
          };
          
          img.onerror = (error) => {
            console.error("Error loading image:", error);
            setLogoProcessingState('error');
            setProcessingProgress(0);
            reject(error);
          };
          
          img.src = imageUrl;
        }
        
        function processImageDirectly() {
        // Use high-resolution rendering for much smoother edges
        const finalThreshold = thresholdValue || 128;
        console.log("Processing image with threshold:", finalThreshold, "Original threshold param:", thresholdValue, "Invert:", invert);
        
        // Store original dimensions on first processing for consistent quality
        // SVGs often have tiny intrinsic dimensions, so we need to scale them up
        if (!originalLogoDimensionsRef.current) {
          // For SVGs or small images, use a minimum size of 800px on the longest side
          const minSize = 800;
          let baseWidth = img.naturalWidth || img.width;
          let baseHeight = img.naturalHeight || img.height;
          
          // Scale up small images/SVGs to ensure good quality
          if (baseWidth < minSize && baseHeight < minSize) {
            const scaleFactor = minSize / Math.max(baseWidth, baseHeight);
            baseWidth = Math.round(baseWidth * scaleFactor);
            baseHeight = Math.round(baseHeight * scaleFactor);
          }
          
          originalLogoDimensionsRef.current = { width: baseWidth, height: baseHeight };
          console.log('📐 Stored original dimensions:', originalLogoDimensionsRef.current);
        }
        
        // Always use stored dimensions for consistent quality across threshold changes
        const storedDims = originalLogoDimensionsRef.current;
        const targetWidth = Math.max(1, Math.floor(storedDims.width * scale));
        const targetHeight = Math.max(1, Math.floor(storedDims.height * scale));
        
        // Use lower resolution scale for preview mode to improve performance
        // 3x gives good quality while staying responsive, 4x for final export
        const highResScale = preview ? 3 : 4; // 3x for preview, 4x for final
        
        // Render at high resolution for smooth edges
        const baseCanvas = renderHighRes(img, targetWidth, targetHeight, finalThreshold, invert, 0, highResScale);
        
        // Store the base canvas (without metallic effect) for fast color updates
        // MUST be done before applying metallic effect
        if (!forUpload) {
          // Create a copy of the base canvas BEFORE applying metallic effect
          const storedCanvas = document.createElement('canvas');
          storedCanvas.width = baseCanvas.width;
          storedCanvas.height = baseCanvas.height;
          const storedCtx = storedCanvas.getContext('2d');
          storedCtx.drawImage(baseCanvas, 0, 0);
          
          if (!preserveTransform) {
            processedLogoCanvasRef.current = storedCanvas;
            console.log('💾 Stored base canvas for fast updates:', storedCanvas.width, 'x', storedCanvas.height);
          }
        }
        
        // Store the Image element for future threshold/invert changes (skip reloading)
        if (!originalLogoImageRef.current && img && img.complete) {
          originalLogoImageRef.current = img;
          console.log('💾 Cached original Image element for fast reprocessing');
        }
        
        // Apply metallic effect (bronze or silver) for UI preview, not for upload
        // Create a new canvas for the final result so we don't modify the stored base
        const canvas = document.createElement('canvas');
        canvas.width = baseCanvas.width;
        canvas.height = baseCanvas.height;
        const canvasCtx = canvas.getContext('2d');
        canvasCtx.drawImage(baseCanvas, 0, 0);
        
        if (!forUpload) {
          const ctx = canvas.getContext('2d');
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;
          
          // Check if selected jug has bronze-etch tag
          const isBronzeEtchValue = isBronzeEtch();
          
          for (let i = 0; i < data.length; i += 4) {
            const a = data[i + 3];
            if (a > 0) {
              // Calculate position for metallic effect
              const x = (i / 4) % canvas.width / canvas.width;
              const y = Math.floor((i / 4) / canvas.width) / canvas.height;
              
              // Create metallic effect - bronze or silver based on jug tag (centered gradient like Jersey)
              const distanceFromCenter = Math.abs(x - 0.5) * 2; // 0 at center, 1 at edges
              const t = (1 - distanceFromCenter) * 0.8 + 0.1; // Light in center, darker at edges
              
              let metallicR, metallicG, metallicB;
              if (isBronzeEtchValue) {
                // Bronze metallic effect - balanced bronze-gold with even lighter base
                const bronzeBase = { r: 155, g: 120, b: 85 }; // Even lighter bronze-gold base
                const bronzeHighlight = { r: 230, g: 190, b: 130 }; // Balanced bronze-gold highlight
                metallicR = Math.round(bronzeBase.r * (1 - t) + bronzeHighlight.r * t);
                metallicG = Math.round(bronzeBase.g * (1 - t) + bronzeHighlight.g * t);
                metallicB = Math.round(bronzeBase.b * (1 - t) + bronzeHighlight.b * t);
              } else {
                // Silver metallic effect (original)
                metallicR = Math.round(130 * (1 - t) + 248 * t);
                metallicG = Math.round(135 * (1 - t) + 249 * t);
                metallicB = Math.round(140 * (1 - t) + 252 * t);
              }
              
              data[i] = metallicR;
              data[i + 1] = metallicG;
              data[i + 2] = metallicB;
              data[i + 3] = a; // Keep original alpha
            }
          }
          
        ctx.putImageData(imageData, 0, 0);
        }
        
        // Create high-quality PNG for Cloudinary upload
        canvas.toBlob((pngBlob) => {
          if (!pngBlob) return;
          
          // Store PNG blob for Cloudinary upload
          setProcessedBlob(pngBlob);
          setProcessedSize({ width: canvas.width, height: canvas.height });
          
          // Create crisp SVG for UI display
          let displayUrl;
          try {
            const svgString = canvasToSVG(canvas, canvas.width, canvas.height);
            const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
            displayUrl = URL.createObjectURL(svgBlob);
            
            // Use SVG for UI display (crisp)
            setProcessedLogoUrl(displayUrl);
          } catch (svgError) {
            console.error("SVG creation for UI failed, using PNG:", svgError);
            // Fallback to PNG for UI if SVG fails
            displayUrl = URL.createObjectURL(pngBlob);
            setProcessedLogoUrl(displayUrl);
          }
          
          setLogoProcessingState('processed');
          setProcessingProgress(100);
          
          // Show the review modal for user to approve or adjust
          // (unless skipModal is true - used when Cancel resets to defaults)
          if (!skipModal) {
            setShowReviewModal(true);
          }
          
          // Don't add to canvas yet - wait for user to accept in review modal
          
          resolve();
        }, 'image/png');
        }
      
      } catch (error) {
        console.error("Local processing error:", error);
        setLogoProcessingState('error');
        setProcessingProgress(0);
        reject(error);
      }
    });
  };

  // Handle file upload
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

      // Convert to base64 immediately (this is the TRUE original client file)
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result; 
        const base64 = dataUrl.split(',')[1];
        setOriginalLogoBase64(base64);
      };
      reader.readAsDataURL(file);

    // Validate image dimensions (must be at least 300px in width or height)
    // SVG files are exempt from dimension requirements
    const validateImageDimensions = (file) => {
      return new Promise((resolve, reject) => {
        // Check if file is SVG - skip dimension validation for SVG files
        const isSVG = file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg');
        
        if (isSVG) {
          console.log('SVG file detected - skipping dimension validation');
          resolve({ width: 'auto', height: 'auto', isSVG: true });
          return;
        }
        
        const img = new Image();
        const url = URL.createObjectURL(file);
        
        img.onload = () => {
          URL.revokeObjectURL(url);
          const width = img.naturalWidth;
          const height = img.naturalHeight;
          
          // Check if image is at least 300px in width OR height
          if (width >= 300 || height >= 300) {
            resolve({ width, height, isSVG: false });
          } else {
            reject(new Error(`Image must be at least 300px in width or height. Current dimensions: ${width}x${height}px`));
          }
        };
        
        img.onerror = () => {
          URL.revokeObjectURL(url);
          reject(new Error('Failed to load image for validation'));
        };
        
        img.src = url;
      });
    };

    try {
      // Validate dimensions before processing
      await validateImageDimensions(file);
      
      // Clear any existing designs when uploading new logo
      setCustomElements([]);
      setSelectedPresetDesign(null);
      setCustomText(''); // Clear custom text

      console.log("Processing logo for etching:", file.name, file.type);
      await processLogoForEtching(file);
    } catch (error) {
      console.error("Image validation error:", error);
      setLogoProcessingState('error');
      setProcessingProgress(0);
      
      // Show error message to user
      alert(error.message || 'Image validation failed. Please try again with a larger image.');
      
      // Reset file input
      e.target.value = '';
    }
  };

  // Handle threshold value change with debouncing
  const handleThresholdChange = async (value) => {
    console.log('Applying threshold change:', value);
    
    if (originalLogoUrl) {
      // Set processing state to show progress
      setLogoProcessingState('processing');
      setProcessingProgress(50);
      
      try {
        // Use preview mode (0.5 scale) for faster threshold/invert changes
        // This is just for UI preview, full quality will be used when adding to cart
        await processImageLocally(originalLogoUrl, { 
          thresholdValue: value,
          keepDrawerOpen: true, // Keep drawer open during processing
          invert: invertEtch,
          preview: true // Use lower resolution for faster processing
        });
        
        // Update processing state to show completion
        setLogoProcessingState('processed');
        setProcessingProgress(100);
        
        console.log('Threshold applied successfully with value:', value);
      } catch (error) {
        console.error('Error applying threshold:', error);
        setLogoProcessingState('error');
        setProcessingProgress(0);
      }
    }
  };

  // Debounced threshold change - waits 500ms after user stops moving slider
  const handleThresholdChangeDebounced = (value) => {
    // Clear any existing timeout
    if (thresholdDebounceRef.current) {
      clearTimeout(thresholdDebounceRef.current);
    }
    
    // Set new timeout
    thresholdDebounceRef.current = setTimeout(() => {
      handleThresholdChange(value);
    }, 500); // Wait 500ms after user stops moving slider
  };
  
  // Threshold change for review modal - uses preview mode for faster updates
  const handleThresholdChangeForModal = async (value) => {
    console.log('Applying threshold change for modal:', value);
    
    if (originalLogoUrl) {
      try {
        // Use requestAnimationFrame to yield to the browser and prevent freezing
        requestAnimationFrame(async () => {
          await processImageLocally(originalLogoUrl, { 
            thresholdValue: value,
            keepDrawerOpen: true,
            invert: invertEtch,
            preview: true // Use 2x resolution for faster slider interaction
          });
          
          setLogoProcessingState('processed');
          console.log('Threshold applied successfully with value:', value);
        });
      } catch (error) {
        console.error('Error applying threshold:', error);
      }
    }
  };
  
  // Debounced threshold change for review modal - shorter delay for responsiveness
  const handleThresholdChangeFullResDebounced = (value) => {
    if (thresholdDebounceRef.current) {
      clearTimeout(thresholdDebounceRef.current);
    }
    
    thresholdDebounceRef.current = setTimeout(() => {
      handleThresholdChangeForModal(value);
    }, 150); // Reduced from 500ms for faster feedback
  };

  // Function to apply rotation to any image blob
  const applyRotationToImage = async (imageUrl, rotation) => {
    if (rotation === 0) {
      // No rotation needed, return original blob
      const response = await fetch(imageUrl);
      return await response.blob();
    }
    
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      img.onload = () => {
        // Calculate rotated dimensions
        const radians = (rotation * Math.PI) / 180;
        const cos = Math.abs(Math.cos(radians));
        const sin = Math.abs(Math.sin(radians));
        
        const canvasWidth = Math.ceil(img.width * cos + img.height * sin);
        const canvasHeight = Math.ceil(img.width * sin + img.height * cos);
        
        // Create canvas for rotation
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        
        // Apply rotation
        ctx.translate(canvasWidth / 2, canvasHeight / 2);
        ctx.rotate((rotation * Math.PI) / 180);
        ctx.drawImage(img, -img.width / 2, -img.height / 2);
        
        // Convert to blob
        canvas.toBlob((blob) => {
          if (blob) {
            console.log('Applied rotation to image:', rotation, 'degrees');
            resolve(blob);
          } else {
            reject(new Error('Failed to create rotated image blob'));
          }
        }, 'image/png');
      };
      
      img.onerror = reject;
      img.src = imageUrl;
    });
  };

  // Generate clean version for upload (no noise, crisp edges)
  const generateCleanUploadVersion = async () => {
    if (!originalLogoUrl) return null;
    
    try {
      console.log('Generating clean upload version (no noise)...');
      
      // Get rotation from customElements if available
      const rotation = customElements.length > 0 ? (customElements[0].rotation || 0) : 0;
      console.log('Applying rotation to upload version:', rotation);
      console.log('CustomElements:', customElements);
      console.log('First element rotation:', customElements[0]?.rotation);
      
      // Process image without noise for clean upload
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      return new Promise((resolve, reject) => {
        img.onload = () => {
          // Use high-resolution rendering for much smoother edges
          const finalThreshold = thresholdValue || 128;
          console.log('Processing clean version with threshold:', finalThreshold);
          
          // Render at high resolution for smooth edges with rotation applied
          const canvas = renderHighRes(img, img.width, img.height, finalThreshold, invertEtch, rotation);
          
          // Convert to PNG for Cloudinary processing (let Cloudinary handle SVG conversion)
          canvas.toBlob((blob) => {
            if (blob) {
              console.log('Clean PNG upload version generated successfully');
              resolve(blob);
            } else {
              reject(new Error('Failed to generate clean upload version'));
            }
          }, 'image/png');
        };
        
        img.onerror = reject;
        img.src = originalLogoUrl;
      });
      
    } catch (error) {
      console.error('Error generating clean upload version:', error);
      throw error;
    }
  };

  // Add to cart with previewUrl property

  
  async function moderateImage(imageUrl) {
    try {
      console.log('🔄 Starting moderation request for:', imageUrl);
      const startTime = Date.now();
      
      // Add timeout to handle cold starts (60 seconds)
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000);
      
      // Use Firebase Functions endpoint
      const res = await fetch('https://moderate-2yordtblma-uc.a.run.app', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ imageUrl }),
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      const duration = Date.now() - startTime;
      console.log(`⏱️ Moderation request took ${duration}ms`);
      
      if (!res.ok) {
        const errorText = await res.text();
        console.error('❌ Moderation API error:', res.status, errorText);
        throw new Error(`Moderation failed: ${res.status} ${errorText}`);
      }
      
      const data = await res.json();
      console.log('✅ Moderation result:', data);
      return data;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.error('⏱️ Moderation request timed out after 60 seconds');
        throw new Error('Moderation request timed out. The server may be starting up (cold start). Please try again.');
      }
      console.error('❌ Error calling moderation API:', error);
      throw error;
    }
  }

  // Google Drive folder ID - get this from the folder URL in Google Drive
  // The folder ID is the long string in the URL: https://drive.google.com/drive/folders/FOLDER_ID_HERE
  const GOOGLE_DRIVE_FOLDER_ID = '0AFXOTJyY31GRUk9PVA';

  // Upload image to Google Drive after Cloudinary upload and moderation
  // Uses backend service account for zero popups - completely automatic
  async function uploadToGoogleDrive(cloudinaryUrl, metadata = {}) {
    // Extract filename from Cloudinary URL or use provided filename
    let fileName = metadata.fileName;
    
    console.log('📤 uploadToGoogleDrive called with:', {
      cloudinaryUrl,
      metadataFileName: metadata.fileName,
      metadataType: metadata.type
    });
    
    // If no filename provided, try to extract from Cloudinary URL
    if (!fileName && cloudinaryUrl) {
      try {
        // Cloudinary URLs typically have format: https://res.cloudinary.com/cloud_name/image/upload/v1234567890/public_id.format
        const urlParts = cloudinaryUrl.split('/');
        const lastPart = urlParts[urlParts.length - 1];
        // Extract public_id and format
        const match = lastPart.match(/^(.+?)\.([^.]+)$/);
        if (match) {
          const publicId = match[1];
          const format = match[2];
          fileName = `${publicId}.${format}`;
          console.log('📁 Extracted filename from URL:', fileName);
        }
      } catch (e) {
        console.warn('Could not extract filename from Cloudinary URL:', e);
      }
    }
    
    // Fallback to generated filename if extraction failed
    if (!fileName) {
      const extension = metadata.type === 'jersey' ? 'svg' : 'png';
      fileName = `${metadata?.type || 'design'}_${Date.now()}.${extension}`;
      console.warn('⚠️ Using fallback filename:', fileName);
    } else {
      console.log('✅ Using filename:', fileName);
    }
    try {
      console.log('📤 Uploading to Google Drive:', cloudinaryUrl);
      const startTime = Date.now();
      
      // Add timeout to handle Render cold starts (60 seconds for free tier)
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000);
      
      // For local testing, use: 'http://localhost:10000/apps/customizer/upload-to-drive'
      // For production, use: 'https://customizer-api-lgj8.onrender.com/apps/customizer/upload-to-drive'
      const res = await fetch('https://uploadtodrive-2yordtblma-uc.a.run.app', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          imageUrl: cloudinaryUrl,
          folderId: GOOGLE_DRIVE_FOLDER_ID,
          fileName: fileName, // Pass the extracted/generated filename
          metadata: metadata // Can include product info, design type, etc.
        }),
        signal: controller.signal,
      });
      
      clearTimeout(timeoutId);
      const duration = Date.now() - startTime;
      console.log(`⏱️ Google Drive upload request took ${duration}ms`);
      
      if (!res.ok) {
        const errorText = await res.text();
        console.error('❌ Google Drive upload failed:', res.status, errorText);
        // Don't throw - this is a non-critical operation
        return { success: false, error: errorText };
      }
      
      const data = await res.json();
      console.log('✅ Google Drive upload successful:', data);
      return { success: true, data };
    } catch (error) {
      if (error.name === 'AbortError') {
        console.error('⏱️ Google Drive upload timed out after 60 seconds');
        return { success: false, error: 'Upload timed out. The server may be starting up (cold start).' };
      }
      console.error('❌ Error uploading to Google Drive:', error);
      // Don't throw - this is a non-critical operation that shouldn't block the flow
      return { success: false, error: error.message };
    }
  }

  // 🔗 Your Firebase HTTPS function URL
  // const FIREBASE_VECTORIZER_URL = 'http://127.0.0.1:5001/customizer-api-8af51/us-central1/vectorize';
  // const FIREBASE_VECTORIZER_URL = 'http://127.0.0.1:5001/customizer-api-8af51/us-central1/vectorizePreprocessed';
  const FIREBASE_VECTORIZER_URL = 'https://us-central1-customizer-api-8af51.cloudfunctions.net/vectorize';
  

  // Helper: Blob → base64 string (no data: prefix)
  const blobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result; // "data:image/png;base64,AAAA..."
        const base64 = dataUrl.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });


  const handleAddToCart = async () => {
    if (!selectedColor || (!processedBlob && customElements.length === 0)) {
      alert('Select a product/color and add a custom design first.');
      return;
    }

    try {
      setAddingToCart(true);
      
      // Show loading modal and reset progress
      setShowLoadingModal(true);
      setUploadProgress(0);
      
      let securePreviewUrl;
      let originalUploadedUrl;
      if (processedBlob) {
        console.log("Processing SVG vectorization for cart...");
      
        setUploadProgress(10);
        const imageBase64 = await blobToBase64(processedBlob);
        console.log('originalLogoBase64', originalLogoBase64);
      
        // 1) Vectorize using your Firebase function
        const vectorizeRes = await fetch(FIREBASE_VECTORIZER_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            imageBase64: originalLogoBase64,
            invert: invertEtch,
            threshold: thresholdValue,
            // highQuality: true
          }),
        });
        // // 1) Vectorize using your Firebase function
        // const vectorizeRes = await fetch(FIREBASE_VECTORIZER_URL, {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify({
        //     imageBase64: imageBase64,
        //     // highQuality: true
        //   }),
        // });
      
        const { svg } = await vectorizeRes.json();
        if (!svg) throw new Error("Vectorization API returned no SVG");
      
        setUploadProgress(25);
      
        // 2) Convert SVG string → Blob
        const svgBlob = new Blob([svg], { type: "image/svg+xml" });
      
        // 3) Upload SVG to Cloudinary
        const formData = new FormData();
        formData.append("file", svgBlob, "vectorized-logo.svg");
        formData.append("upload_preset", "upload_test");
      
        console.log("Uploading SVG to Cloudinary...");
        setUploadProgress(40);
      
        const uploadRes = await fetch(
          "https://api.cloudinary.com/v1_1/dgepygozk/image/upload",
          { method: "POST", body: formData }
        );
      
        setUploadProgress(60);
      
        if (!uploadRes.ok) {
          const txt = await uploadRes.text();
          throw new Error(`Cloudinary SVG upload failed: ${txt}`);
        }
      
        const uploaded = await uploadRes.json();
        console.log("SVG upload successful:", uploaded);
      
        securePreviewUrl = uploaded.secure_url;
      
        // 3b) Upload the original (unprocessed) logo to Cloudinary for comparison
        console.log("Uploading original logo to Cloudinary...");
        const originalBlob = await fetch(`data:image/png;base64,${originalLogoBase64}`).then(r => r.blob());
        const originalFormData = new FormData();
        originalFormData.append("file", originalBlob, "original-logo.png");
        originalFormData.append("upload_preset", "originals");
        originalFormData.append("folder", "customizer-originals");
      
        const originalUploadRes = await fetch(
          "https://api.cloudinary.com/v1_1/dgepygozk/image/upload",
          { method: "POST", body: originalFormData }
        );
        if (originalUploadRes.ok) {
          const originalUploaded = await originalUploadRes.json();
          console.log("Original logo upload successful:", originalUploaded);
          console.log("Original logo URL:", originalUploaded.secure_url);
          originalUploadedUrl = originalUploaded.secure_url;
        } else {
          console.warn("Original logo upload failed (non-critical):", await originalUploadRes.text());
        }
      
        // 4) Save backup to Drive (optional)
        const cloudinaryFileName = uploaded.public_id + ".svg";
      
        setUploadProgress(75);
      
        await uploadToGoogleDrive(securePreviewUrl, {
          type: "logo",
          fileName: cloudinaryFileName,
          productId: selectedProduct?.id,
          colorId: selectedColor?.id,
          timestamp: new Date().toISOString(),
        });
      
        setUploadProgress(85);
      }
      
       else if (customElements.length > 0) {
        // Handle custom elements (metallic text, jersey, or preset designs)
        console.log('Processing custom element for cart...');
        
        setUploadProgress(10);
        
        const customElement = customElements[0];
        
        if (customElement.type === 'image' && customElement.imageUrl) {
          // Check if this is a preset design (no Cloudinary upload needed)
          if (selectedPresetDesign) {
            console.log('Using preset design, no Cloudinary upload needed');
            setUploadProgress(85);
            securePreviewUrl = selectedPresetDesign.featured_image?.src || selectedPresetDesign.image?.src || selectedPresetDesign.image?.url;
          } else {
            // This is a custom metallic element (text or jersey) - upload to Cloudinary
            console.log('Processing custom metallic element for cart...');
            
            let elementBlob;
            let fileName;

            // Jersey branch
            console.log('customElement', customElement);
            console.log('jerseyNumber', jerseyNumber);
            console.log('jerseyText', jerseyText);

            if (customElement.imageUrl.includes('blob:') && (jerseyNumber || jerseyText)) {
              console.log('Creating black version of jersey design for Cloudinary...');

              const svgString = await createJerseyDesignForUpload(
                jerseyNumber,
                jerseyText,
                jerseyTextPosition,
                jerseyCurveText
              );
              console.log('svgString', svgString);
              
              const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });

              const elementRotation = customElement.rotation || 0;
              if (elementRotation !== 0) {
                console.log('Applying rotation to jersey design:', elementRotation);
                const svgUrl = URL.createObjectURL(svgBlob);
                elementBlob = await applyRotationToImage(svgUrl, elementRotation);
                URL.revokeObjectURL(svgUrl);
                fileName = 'jersey-design.png'; // rotation turns it into PNG
              } else {
                elementBlob = svgBlob;
                fileName = 'jersey-design.svg'; // stays SVG
              }
            } else {
              // Metallic element branch
              const elementRotation = customElement.rotation || 0;
              const sourceUrl = customElement.highResUrl || customElement.imageUrl;
              elementBlob = await applyRotationToImage(sourceUrl, elementRotation);
              fileName = 'metallic-element.png';
            }

            setUploadProgress(25);
            
            // ✅ Only one FormData build
            const formData = new FormData();
            formData.append('file', elementBlob, fileName);
            
            // Use different presets: 'upload_test' for SVGs (has vectorize), 'originals' for PNGs (no vectorize)
            formData.append('upload_preset', 'hydrojug_customizer');


            console.log('Uploading metallic element to Cloudinary...');
            
            setUploadProgress(35);
            
            // Use standard upload URL
            let uploadUrl = 'https://api.cloudinary.com/v1_1/dgepygozk/image/upload';
            
            const uploadRes = await fetch(uploadUrl, {
              method: 'POST',
              body: formData,
            });
            
            setUploadProgress(60);
            
            if (!uploadRes.ok) {
              const txt = await uploadRes.text();
              throw new Error(`Cloudinary upload failed: ${txt}`);
            }
            
            const uploaded = await uploadRes.json();
            console.log('Element upload successful:', uploaded);
            
            setUploadProgress(70);
            
            // Upload to Google Drive (custom elements don't go through moderation, so upload directly)
            // Zero popups - uses backend service account
            // Extract filename from Cloudinary response (public_id + format)
            const cloudinaryFileName = uploaded.public_id 
              ? `${uploaded.public_id}.${uploaded.format || (fileName.includes('.svg') ? 'svg' : 'png')}` 
              : fileName; // Fallback to the fileName we set earlier
            
            setUploadProgress(75);
            
            const driveUploadResult = await uploadToGoogleDrive(uploaded.secure_url, {
              type: customElement.type === 'image' && (jerseyNumber || jerseyText) ? 'jersey' : 'custom-text',
              fileName: cloudinaryFileName, // Use Cloudinary filename
              productId: selectedProduct?.id,
              colorId: selectedColor?.id,
              designId: customElement.isPresetDesign ? selectedPresetDesign?.sku || selectedPresetDesign?.title : 'custom',
              timestamp: new Date().toISOString()
            });
            
            // Check if Google Drive upload failed
            if (!driveUploadResult.success) {
              console.error('Google Drive backup failed:', driveUploadResult.error);
              setAddingToCart(false);
              setShowLoadingModal(false);
              alert('There was an error uploading your image. Please refresh the page and try again.\n\nIf the problem persists, please contact us at service@thehydrojug.com');
              return;
            }
            
            setUploadProgress(85);
            
            // Use the secure_url directly - rotation should be baked into the image if needed
            securePreviewUrl = uploaded.secure_url;
          }
        }
      }
      
      if (!securePreviewUrl) {
        throw new Error('Failed to generate preview URL');
      }
      
      console.log('Secure Preview URL:', securePreviewUrl);

      // Determine etch type and design info
      const isPresetDesign = !!selectedPresetDesign;
      const isJerseyDesign = !!(jerseyNumber || jerseyText);
      const isCustomUpload = !!processedBlob;
      const isCustomText = !!customText;
      
      // Determine etchType dynamically
      let etchType;
      let designType;
      if (isPresetDesign) {
        etchType = 'design';
      } else {
        etchType = 'custom-upload';
      }
      if (isCustomUpload) {
        designType = 'custom-upload';
      } else if (isJerseyDesign) {
        designType = 'jersey';
      } else if (isCustomText) {
        designType = 'custom-text';
      } else {
        designType = 'design';
      }
      
      const designId = isPresetDesign ? (selectedPresetDesign.sku || selectedPresetDesign.title || selectedPresetDesign.name || 'unknown') : 'custom';
      const previewUrl = securePreviewUrl; // Both use securePreviewUrl
      
      // Get rotation if preset design
      const rotation = isPresetDesign && customElements.length > 0 ? (customElements[0].rotation || 0) : undefined;
      
      // Build etch info object
      const etchInfo = {
        etchType: etchType,
        designId: designId,
        previewUrl: previewUrl,
        designType: designType
      };
      
      // Add rotation only if it exists and it's a preset design
      if (rotation !== undefined && isPresetDesign && rotation !== 0) {
        etchInfo.rotation = rotation;
      }
      if (originalUploadedUrl) {
        etchInfo.originalUrl = originalUploadedUrl;
      }
      
      console.log('Etch Info:', etchInfo);

      setUploadProgress(90);

      // Add to Shopify cart with SVG previewUrl
      const variantId = selectedColor.variants?.[0]?.id;
      if (!variantId) throw new Error('No variant available to add to cart');

      const cartRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                "Etch Preview": securePreviewUrl,
                'etchInfo': etchInfo,
                'Notice': 'Final Sale'
              }
            }
          ]
        })
      });

      if (!cartRes.ok) {
        const text = await cartRes.text();
        throw new Error(text);
      }

      setUploadProgress(100);

      // Small delay to show completion
      await new Promise(resolve => setTimeout(resolve, 500));

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show();

      setAddingToCart(false);
      setShowLoadingModal(false);
    } catch (err) {
      console.error('Add to cart error:', err);
      setAddingToCart(false);
      setShowLoadingModal(false);
      alert('There was an issue adding to cart.');
    }
  };

  const addTextElement = () => {
    if (!customText.trim()) return;
    
    // Clear any existing designs when adding new text
    setCustomElements([]);
    setSelectedPresetDesign(null);
    // Clear logo states
    setLogoProcessingState('idle');
    setProcessedLogoUrl(null);
    setOriginalLogoUrl(null);
    setProcessedBlob(null);
    processedLogoCanvasRef.current = null;
    originalLogoImageRef.current = null;
    originalLogoDimensionsRef.current = null;
    presetDesignCanvasRef.current = null;
    // Clear jersey states
    setJerseyNumber('');
    setJerseyText('');
    setJerseyTextPosition('below');
    
    // Center the text on the canvas (dynamic size)
    const canvasWidth = window.innerWidth <= 768 ? 400 : 600; // Use mobile size if on mobile
    const canvasHeight = window.innerWidth <= 768 ? 400 : 600; // Use mobile size if on mobile
    
    // Create metallic text effect
    createMetallicText(customText, selectedFont, canvasWidth, canvasHeight);
    
    // Close drawer but keep text for easy editing
    setIsDrawerOpen(false);
  };


  // Function to create metallic text effect
  const createMetallicText = (text, fontFamily, canvasWidth, canvasHeight) => {
    try {
      console.log('Creating metallic text:', { text, fontFamily, canvasWidth, canvasHeight });
      
      // Clear all other style states when creating custom text
      setSelectedPresetDesign(null);
      // Clear logo states
      setLogoProcessingState('idle');
      setProcessedLogoUrl(null);
      setOriginalLogoUrl(null);
      setProcessedBlob(null);
      setOriginalLogoBase64(null);
      processedLogoCanvasRef.current = null;
      // Clear jersey states
      setJerseyNumber('');
      setJerseyText('');
      setJerseyTextPosition('below');
      
      // Create a temporary canvas to measure text properly
      const measureCanvas = document.createElement('canvas');
      const measureCtx = measureCanvas.getContext('2d');
      
      // Use a larger base font size for better quality
      const baseFontSize = 48; // Increased from 24px
      const fontWeight = fontFamily === 'Montserrat' ? '600' : '400';
      measureCtx.font = `${fontWeight} ${baseFontSize}px ${fontFamily}`;
      measureCtx.textAlign = 'center';
      measureCtx.textBaseline = 'middle';
      
      // Measure text to get its actual bounds
      const textMetrics = measureCtx.measureText(text);
      const textWidth = textMetrics.width;
      const textHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;
      
      console.log('Text metrics:', { textWidth, textHeight, fontFamily });
      
      // Create a new canvas just for the text
      const textCanvas = document.createElement('canvas');
      const textCtx = textCanvas.getContext('2d');
      
      // Use ultra-high resolution for crisp text (16x scale for ultra-smooth curves)
      const scale = 16;
      const padding = 60; // Increased padding for better spacing
      const baseWidth = textWidth + padding;
      const baseHeight = textHeight + padding;
      
      // Ensure minimum size for very short text
      const finalWidth = Math.max(baseWidth, 120);
      const finalHeight = Math.max(baseHeight, 80);
      
      // Set canvas size with ultra-high resolution
      textCanvas.width = finalWidth * scale;
      textCanvas.height = finalHeight * scale;
      
      // Scale the context for ultra-high resolution
      textCtx.scale(scale, scale);
      
      // Advanced quality settings for ultra-smooth rendering
      textCtx.imageSmoothingEnabled = true;
      textCtx.imageSmoothingQuality = 'high';
      
      // Additional canvas optimizations for smoothest possible curves
      textCtx.textRenderingOptimization = 'optimizeQuality';
      textCtx.antialias = true;
      
      // Set font rendering hints for maximum quality
      if (textCtx.fontKerning) textCtx.fontKerning = 'normal';
      if (textCtx.fontStretch) textCtx.fontStretch = 'normal';
      if (textCtx.fontVariantCaps) textCtx.fontVariantCaps = 'normal';
      if (textCtx.textRendering) textCtx.textRendering = 'optimizeQuality';
      
      console.log('Text canvas size:', { 
        baseWidth: finalWidth, 
        baseHeight: finalHeight, 
        scaledWidth: textCanvas.width, 
        scaledHeight: textCanvas.height 
      });
      
      // Enable high-quality text rendering
      textCtx.imageSmoothingEnabled = false;
      textCtx.textRenderingOptimization = 'optimizeQuality';
      
      // Draw text in black for processing with larger font size
      textCtx.font = `${fontWeight} ${baseFontSize}px ${fontFamily}`;
      textCtx.textAlign = 'center';
      textCtx.textBaseline = 'middle';
      textCtx.fillStyle = 'black';
      textCtx.fillText(text, finalWidth / 2, finalHeight / 2);
      
      // Get image data for processing
      const imageData = textCtx.getImageData(0, 0, textCanvas.width, textCanvas.height);
      const data = imageData.data;
      
      console.log('Processing image data, pixels:', data.length / 4);
      
      // Apply metallic effect to text pixels with better detection
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        
        // Ultra-inclusive text detection for maximum smoothness - captures all anti-aliased pixels
        // This preserves even the lightest anti-aliased edges for ultra-smooth curves
        const isTextPixel = a > 20 && (r + g + b) < 250; // Very inclusive for ultra-smooth edges
        
        if (isTextPixel) {
          // Calculate position for metallic effect
          const x = (i / 4) % textCanvas.width / textCanvas.width;
          const y = Math.floor((i / 4) / textCanvas.width) / textCanvas.height;
          
          // Check if selected jug has bronze-etch tag
          const isBronzeEtchValue = isBronzeEtch();
          
          // Create metallic effect - bronze or silver based on jug tag (centered gradient like Jersey)
          const distanceFromCenter = Math.abs(x - 0.5) * 2; // 0 at center, 1 at edges
          const t = (1 - distanceFromCenter) * 0.8 + 0.1; // Light in center, darker at edges
          
          let metallicR, metallicG, metallicB;
          if (isBronzeEtchValue) {
            // Bronze metallic effect - balanced bronze-gold with even lighter base
            const bronzeBase = { r: 155, g: 120, b: 85 }; // Even lighter bronze-gold base
            const bronzeHighlight = { r: 230, g: 190, b: 130 }; // Balanced bronze-gold highlight
            metallicR = Math.round(bronzeBase.r * (1 - t) + bronzeHighlight.r * t);
            metallicG = Math.round(bronzeBase.g * (1 - t) + bronzeHighlight.g * t);
            metallicB = Math.round(bronzeBase.b * (1 - t) + bronzeHighlight.b * t);
          } else {
            // Silver metallic effect (original)
            metallicR = Math.round(130 * (1 - t) + 248 * t);
            metallicG = Math.round(135 * (1 - t) + 249 * t);
            metallicB = Math.round(140 * (1 - t) + 252 * t);
          }
          
          data[i] = metallicR;
          data[i + 1] = metallicG;
          data[i + 2] = metallicB;
          data[i + 3] = 255; // Keep fully opaque
        } else {
          // Make background transparent
          data[i + 3] = 0;
        }
      }
      
      // Add subtle noise for brushed metal effect
      const noiseAmount = 1; // Reduced noise for text
      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] === 255) {
          const n = (Math.random() - 0.5) * noiseAmount;
          data[i] = Math.max(0, Math.min(255, data[i] + n));
          data[i + 1] = Math.max(0, Math.min(255, data[i + 1] + n));
          data[i + 2] = Math.max(0, Math.min(255, data[i + 2] + n));
        }
      }
      
      // Put the processed image data back
      textCtx.putImageData(imageData, 0, 0);
      
      // Apply subtle smoothing filter for ultra-smooth curves
      textCtx.filter = 'blur(0.5px)';
      textCtx.globalCompositeOperation = 'source-over';
      textCtx.drawImage(textCanvas, 0, 0);
      textCtx.filter = 'none'; // Reset filter
      
      console.log('Metallic effect applied with smoothing, converting to blob...');
      
      // Create a display-optimized version for UI (4x scale for perfect balance)
      const displayCanvas = document.createElement('canvas');
      const displayCtx = displayCanvas.getContext('2d');
      const displayScale = 4; // Optimal for UI display
      
      displayCanvas.width = finalWidth * displayScale;
      displayCanvas.height = finalHeight * displayScale;
      
      // Enable high-quality scaling for display version
      displayCtx.imageSmoothingEnabled = true;
      displayCtx.imageSmoothingQuality = 'high';
      
      // Draw the high-res version scaled down with high quality
      displayCtx.drawImage(textCanvas, 0, 0, displayCanvas.width, displayCanvas.height);
      
      // Convert display version to blob
      displayCanvas.toBlob((displayBlob) => {
        if (!displayBlob) {
          console.error('Failed to create display blob from canvas');
          return;
        }
        
        const displayUrl = URL.createObjectURL(displayBlob);
        
        // Convert high-res version to blob for Cloudinary
      textCanvas.toBlob((blob) => {
        if (!blob) {
          console.error('Failed to create blob from canvas');
          return;
        }
        
        console.log('High-res blob created:', blob.size, 'bytes');
        const highResUrl = URL.createObjectURL(blob);
        console.log('Display URL created:', displayUrl);
        console.log('High-res URL created for Cloudinary:', highResUrl);
        
        // Get dynamic styles based on selected product and text length
        const productType = selectedProduct?.collectionHandle || 'traveler-40oz';
        const styles = getCustomElementStyles(productType, 'text', text.length);
        
        // Create the text element with the display-optimized image for UI
        const newElement = {
          type: 'image', // Treat as image since it's now a processed image
          imageUrl: displayUrl, // Use display-optimized version for UI
          highResUrl: highResUrl, // Store high-res version for Cloudinary
          width: styles.width,
          height: styles.height,
          top: styles.top,
          left: styles.left,
          right: styles.right,
          margin: styles.margin,
          rotation: 0,
          isPresetDesign: false,
          textLength: text.length
        };
        
        console.log('New metallic text element created:', newElement);
        
        // Replace all existing elements with the new metallic text element
        setCustomElements([newElement]);
        console.log("Added metallic text element:", newElement);
        }, 'image/png', 1.0); // Maximum quality for high-res version
      }, 'image/png', 1.0); // Maximum quality for display version
      
    } catch (error) {
      console.error("Error creating metallic text:", error);
      
      // Fallback to regular text if metallic processing fails
      const newElement = {
        type: 'text',
        text: text,
        x: canvasWidth / 2,
        y: canvasHeight / 2,
        fontSize: 24,
        fontFamily: fontFamily,
        fill: '#808080', // Fallback to gray color
        align: 'center',
        verticalAlign: 'middle',
        rotation: 0
      };
      
      setCustomElements([newElement]);
      console.log("Added fallback text element:", newElement);
    }
  };

  // Function to get dynamic styles based on product type
  const getCustomElementStyles = (productType, elementType, textLength = 0) => {
    console.log("type", productType);
    console.log("elementType", elementType);
    const styles = {
      width: '150px',
      height: 'auto',
      top: '15%',
      margin: '0 auto',
      left: 0,
      right: 0,
    };

    switch (productType) {
      case 'traveler-40oz':
        styles.width = "33%";
        styles.height = "35%";
        styles.top = '15%';
        break;
      case 'traveler-32oz':
        styles.width = "27%";
        styles.height = "39.5%";
        styles.top = '20%';
        break;
      case 'traveler-20oz':
        styles.width = "22%";
        styles.height = "27%";
        styles.top = '35%';
        break;
      case 'coffee-travelers':
        styles.width = "22%";
        styles.height = "27%";
        styles.top = '35%';
        break;
      case 'sport-40oz':
        styles.width = '27%';
        styles.height = '38.5%';
        styles.top = '17%';
        styles.left = '-11px';
        break;
      case 'sport-32oz':
        styles.width = '21%';
        styles.height = '35.2%';
        styles.top = '23%';
        styles.left = '-11px';
        break;
      case 'sport-20oz':
        styles.width = '19%';
        styles.height = '29.3%';
        styles.top = '34%';
        styles.left = '-11px';

        break;
      case 'sport-14oz':
        styles.width = '24%';
        styles.height = '28%';
        styles.top = '41%';
        styles.left = '-4px';

        break;
      case 'stainless-64oz':
          styles.width = '33.5%';
        styles.height = '47%';
        styles.top = '42.5%';
        break;
      case 'can-coolers-slim':
        styles.width = '28%';
        styles.height = '33%';
        styles.top = '44%';
        break;
      case 'can-coolers-standard':
        styles.width = '28%';
        // styles.height = '36%';
        styles.top = '51%';
        break;
      case 'can-cooler-16oz':
        styles.width = '29%';
        styles.height = '34%';
        styles.top = '41%';
        break;
      case 'everyday-tumbler-14oz':
        styles.width = '25%';
        styles.height = '24%';
        styles.top = '50%';
        break;
      case 'everyday-tumbler-20oz':
        styles.width = '27%';
        styles.height = '26.5%';
        styles.top = '40%';
        break;
      case 'insulated-shaker':
        styles.width = '19%';
        styles.height = '29%';
        styles.top = '42%';
        break;
      default:
        break;
    }

    return styles;
  };

  // Create SVG version of jersey design with curved text support
  const createSVGJersey = async (number, text, textPosition, width, height, isCurved = false, forCloudinary = false) => {
    // Create temporary DOM element to measure actual text dimensions
    const tempDiv = document.createElement('div');
    tempDiv.style.position = 'absolute';
    tempDiv.style.visibility = 'hidden';
    tempDiv.style.fontFamily = 'Jersey M54, Arial, sans-serif';
    tempDiv.style.fontSize = '220px'; // Increased from 180px for larger display
    tempDiv.style.fontWeight = 'bold';
    tempDiv.textContent = number;
    document.body.appendChild(tempDiv);
    
    const actualNumberHeight = tempDiv.offsetHeight;
    document.body.removeChild(tempDiv);
    
    // Use actual measured height for centering
    // Need larger offset to align the visual center of the number with element center
    const numberY = (height / 2) + (actualNumberHeight * 0.225); // Larger offset for proper visual centering
    
    // Calculate dynamic text font size based on text length
    const textLength = text.length;
    let textFontSize;
    if (textLength <= 4) {
      textFontSize = 90;
    } else if (textLength <= 8) {
      textFontSize = 70;
    } else if (textLength <= 12) {
      textFontSize = 50;
    } else {
      textFontSize = 40;
    }
    
    // Calculate relative text height based on font size as percentage of canvas
    let textHeightPercent;
    if (textLength <= 4) {
      textHeightPercent = 0.25; // 90px text = ~25% of canvas height
    } else if (textLength <= 8) {
      textHeightPercent = 0.20; // 70px text = ~20% of canvas height
    } else if (textLength <= 12) {
      textHeightPercent = 0.14; // 50px text = ~14% of canvas height
    } else {
      textHeightPercent = 0.11; // 40px text = ~11% of canvas height
    }
    const textRelativeHeight = height * textHeightPercent;
    
    // Calculate positioning using relative measurements and percentage-based gap
    const gapPercent = 0.06; // Reduced gap to prevent text cutoff
    const gap = height * gapPercent;
    
    // Measure actual text height for positioning
    const tempTextDiv = document.createElement('div');
    tempTextDiv.style.position = 'absolute';
    tempTextDiv.style.visibility = 'hidden';
    tempTextDiv.style.fontFamily = 'Jersey M54, Arial, sans-serif';
    tempTextDiv.style.fontSize = `${textFontSize}px`;
    tempTextDiv.style.fontWeight = 'bold';
    tempTextDiv.textContent = text;
    document.body.appendChild(tempTextDiv);
    
    const actualTextHeight = tempTextDiv.offsetHeight;
    document.body.removeChild(tempTextDiv);
    
    // Scale down the measured heights to match SVG rendering
    // DOM measurements are larger than SVG text, so we need to scale them down
    const svgScaleFactor = 0.5; // Increased scale factor for better spacing calculations
    const svgNumberHeight = actualNumberHeight * svgScaleFactor;
    const svgTextHeight = actualTextHeight * svgScaleFactor;

    // Use the actual measured text height from our DOM measurement
    const actualTextHeightScaled = actualTextHeight * svgScaleFactor;
    
    // Define number dimensions using scaled height
    const numberTop = numberY - (svgNumberHeight / 2);
    const numberBottom = numberY + (svgNumberHeight / 2);
    
    
    // Use font-size compensated positioning to maintain consistent visual spacing
    // Compensate for the fact that smaller fonts need different positioning to appear consistent
    const baseFontSize = 90; // Reference font size
    const fontSizeRatio = textFontSize / baseFontSize; // How much smaller/larger than base
    
    const textY = textPosition === 'above' ? 
      numberY - (height * 0.525) : // Above: fixed position
      numberY + (height * 0.125); // Below: compensate for font size
    const curveAmount = width * 0.10; // 10% curve
    
    // Calculate control point based on the actual curved line position
    const curvedLineY = textPosition === 'above' ? 
      textY + (actualTextHeightScaled * 0.2): // Above: use textY as is
      textY + (actualTextHeightScaled * 0.55); // Below: same compensation as straight text
    
    const controlY = textPosition === 'above' ? curvedLineY - curveAmount : curvedLineY + curveAmount;
    
    // Create curved path for text
    const startX = width * 0.1; // Use even more of the available width
    const endX = width * 0.9;   // Use even more of the available width
    const pathId = 'jerseyCurve';
    
    // Generate curved path using quadratic Bézier curve
    // For straight lines, use the actual measured font metrics to position text consistently
    // The key insight: SVG textPath ignores baseline attributes, so we must position the path precisely
    
 
    
    // For "below", position the path so the text top is always at the same visual position
    // We need to account for how SVG positions text on paths (typically centers on the path)
    const straightLineY = textPosition === 'above' ? 
      textY : // Above: use textY as is
      textY + (actualTextHeightScaled * 0.85); // Below: offset by 70% of the actual text height
    
    // Use the same curvedLineY calculated above for the path
    
    const curvePath = isCurved ? 
      `M ${startX},${curvedLineY} Q ${width/2},${controlY} ${endX},${curvedLineY}` : 
      `M ${startX},${straightLineY} L ${endX},${straightLineY}`;
    
    // Try to load the font as a data URI
    let fontDataUri = '';
    try {
      const fontResponse = await fetch('https://cdn.shopify.com/s/files/1/0110/7827/1033/files/Jersey_M54.ttf?v=1758053820');
      const fontBuffer = await fontResponse.arrayBuffer();
      const fontBase64 = btoa(String.fromCharCode(...new Uint8Array(fontBuffer)));
      fontDataUri = `data:font/truetype;base64,${fontBase64}`;
    } catch (error) {
      console.warn('Could not load font as data URI, using fallback:', error);
    }
    
    // Create different SVG versions for UI display vs Cloudinary upload
    if (forCloudinary) {
      // Black version with font for Cloudinary processing
      return `
        <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            ${fontDataUri ? `
            <style>
              @font-face {
                font-family: 'Jersey M54';
                src: url('${fontDataUri}') format('truetype');
              }
            </style>
            ` : ''}
            <path id="${pathId}" d="${curvePath}" fill="transparent" />
          </defs>
          <text x="${width / 2}" y="${numberY}" font-family="Jersey M54, Arial, sans-serif" font-size="220" font-weight="bold" text-anchor="middle" text-baseline="middle" fill="black">${number}</text>
          <text font-family="Jersey M54, Arial, sans-serif" font-size="${textFontSize}" font-weight="bold" alignment-baseline="top" text-baseline="top" fill="black">
            <textPath xlink:href="#${pathId}" startOffset="50%" text-anchor="middle" text-baseline="top" alignment-baseline="top">${text}</textPath>
          </text>
        </svg>
      `;
    } else {
      // Full metallic version for UI display
      return `
        <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            ${fontDataUri ? `
            <style>
              @font-face {
                font-family: 'Jersey M54';
                src: url('${fontDataUri}') format('truetype');
              }
            </style>
            ` : ''}
            <linearGradient id="jerseyGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              ${(() => {
                // Check if selected jug has bronze-etch tag
                const isBronzeEtchValue = isBronzeEtch();
                
                if (isBronzeEtchValue) {
                  // Bronze gradient - balanced bronze-gold with even lighter ends
                  return `
                    <stop offset="0%" stop-color="#9B7855" />
                    <stop offset="25%" stop-color="#A6824E" />
                    <stop offset="50%" stop-color="#E6BE82" />
                    <stop offset="75%" stop-color="#A6824E" />
                    <stop offset="100%" stop-color="#9B7855" />
                  `;
                } else {
                  // Silver gradient (original)
                  return `
                    <stop offset="0%" stop-color="#999999" />
                    <stop offset="25%" stop-color="#cccccc" />
                    <stop offset="50%" stop-color="#ffffff" />
                    <stop offset="75%" stop-color="#cccccc" />
                    <stop offset="100%" stop-color="#999999" />
                  `;
                }
              })()}
            </linearGradient>
            <path id="${pathId}" d="${curvePath}" fill="transparent" />
          </defs>
          <text x="${width / 2}" y="${numberY}" font-family="Jersey M54, Arial, sans-serif" font-size="220" font-weight="bold" text-anchor="middle" text-baseline="middle" fill="url(#jerseyGradient)">${number}</text>
          <text class="jersey-text" font-family="Jersey M54, Arial, sans-serif" font-size="${textFontSize}" font-weight="bold" alignment-baseline="top" text-baseline="top" fill="url(#jerseyGradient)" style="line-height: 0;">
            <textPath xlink:href="#${pathId}" startOffset="50%" text-anchor="middle" text-baseline="top" alignment-baseline="top" style="line-height: 0;">${text}</textPath>
          </text>
        </svg>
      `;
    }
  };

  // Function to convert textPath to actual SVG path outlines for laser compatibility
  const convertTextPathToSVGPaths = async (text, curvePath, fontSize, fontFamily) => {
    // Create a temporary SVG element to measure text and create paths
    const tempSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    tempSvg.style.position = 'absolute';
    tempSvg.style.left = '-9999px';
    tempSvg.style.top = '-9999px';
    document.body.appendChild(tempSvg);
    
    try {
      // Parse the curve path to get control points
      const pathMatch = curvePath.match(/M\s*([\d.]+),([\d.]+)\s*Q\s*([\d.]+),([\d.]+)\s*([\d.]+),([\d.]+)/);
      if (!pathMatch) {
        // Fallback for straight line
        const lineMatch = curvePath.match(/M\s*([\d.]+),([\d.]+)\s*L\s*([\d.]+),([\d.]+)/);
        if (lineMatch) {
          const [, startX, startY, endX, endY] = lineMatch.map(Number);
          const centerX = (startX + endX) / 2;
          return `<text x="${centerX}" y="${startY}" font-family="${fontFamily}, Arial, sans-serif" font-size="${fontSize}" font-weight="bold" text-anchor="middle" fill="black">${text}</text>`;
        }
        return '';
      }
      
      const [, startX, startY, controlX, controlY, endX, endY] = pathMatch.map(Number);
      
      // Create individual text elements for each character positioned along the curve
      const characters = text.split('');
      let svgElements = '';
      
      // Calculate character positions along the curve
      const totalLength = Math.sqrt(Math.pow(endX - startX, 2) + Math.pow(endY - startY, 2));
      const charSpacing = totalLength / Math.max(characters.length - 1, 1);
      
      characters.forEach((char, index) => {
        if (char.trim() === '') return; // Skip spaces for now
        
        // Calculate position along curve (0 to 1)
        const t = characters.length === 1 ? 0.5 : index / (characters.length - 1);
        
        // Quadratic Bézier curve formula: B(t) = (1-t)²P₀ + 2(1-t)tP₁ + t²P₂
        // X coordinates are linear (straight line horizontally)
        const x = startX + t * (endX - startX);
        // Y coordinates follow the curve
        const y = Math.pow(1 - t, 2) * startY + 2 * (1 - t) * t * controlY + Math.pow(t, 2) * endY;
        
        // Calculate rotation angle for the character
        const dy = 2 * (1 - t) * (controlY - startY) + 2 * t * (endY - controlY);
        const dx = endX - startX;
        const angle = Math.atan2(dy, dx) * (180 / Math.PI);
        
        // Create individual text element for this character
        svgElements += `<text x="${x}" y="${y}" font-family="${fontFamily}, Arial, sans-serif" font-size="${fontSize}" font-weight="bold" text-anchor="middle" fill="black" transform="rotate(${angle} ${x} ${y})">${char}</text>`;
      });
      
      return svgElements;
      
    } finally {
      // Clean up temporary SVG
      document.body.removeChild(tempSvg);
    }
  };

  // Function to create jersey-style metallic design using SVG textPath
  const createJerseyDesign = async (number, text, textPosition, canvasWidth, canvasHeight) => {
    try {
      console.log('Creating jersey design:', { number, text, textPosition, canvasWidth, canvasHeight });
      
      // Clear all other style states when creating jersey design
      setSelectedPresetDesign(null);
      // Clear text states
      setCustomText('');
      // Clear logo states
      setLogoProcessingState('idle');
      setProcessedLogoUrl(null);
      setOriginalLogoUrl(null);
      setProcessedBlob(null);
      setOriginalLogoBase64(null);
      processedLogoCanvasRef.current = null;
      presetDesignCanvasRef.current = null;
      
      // Get dynamic styles based on selected product and text length first
      const productType = selectedProduct?.collectionHandle || 'traveler-40oz';
      const totalTextLength = (number + text).length;
      const styles = getCustomElementStyles(productType, 'text', totalTextLength);
      
                // Convert percentage dimensions to pixel values for SVG generation
                const baseWidth = 350; // Increased width to reduce whitespace
                const baseHeight = 400;
      
      // Generate SVG with curved text using textPath
      const svgString = await createSVGJersey(number, text, textPosition, baseWidth, baseHeight, jerseyCurveText);
      
      // Convert SVG string to blob
      const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });
      const svgUrl = URL.createObjectURL(svgBlob);

      // Create the jersey element with the SVG
      const newElement = {
        type: 'image',
        imageUrl: svgUrl,
        width: styles.width,
        height: styles.height,
        top: styles.top,
        left: styles.left,
        right: styles.right,
        margin: styles.margin,
        rotation: 0,
        isPresetDesign: false,
        textLength: totalTextLength
      };
      
      console.log('New SVG jersey element created:', newElement);
      console.log('Styles from getCustomElementStyles:', styles);
      console.log('Product type:', productType, 'Text length:', totalTextLength);
      
      // Replace all existing elements with the new SVG jersey element
      setCustomElements([newElement]);
      console.log("Added SVG jersey element:", newElement);
      
    } catch (error) {
      console.error('Error in createJerseyDesign:', error);
    }
  };

  // Auto-update jersey design when inputs change (debounced)
  useEffect(() => {
    // Only auto-update if we have a jersey number and we're on the jersey tab
    if (!jerseyNumber.trim() || activeTab !== 'jersey') {
      return;
    }

    // Clear any existing debounce timeout
    if (jerseyDebounceRef.current) {
      clearTimeout(jerseyDebounceRef.current);
    }

    // Debounce the jersey design creation
    jerseyDebounceRef.current = setTimeout(() => {
      const canvasWidth = window.innerWidth <= 768 ? 400 : 600;
      const canvasHeight = window.innerWidth <= 768 ? 400 : 600;
      createJerseyDesign(jerseyNumber, jerseyText, jerseyTextPosition, canvasWidth, canvasHeight);
    }, 300);

    // Cleanup on unmount or when dependencies change
    return () => {
      if (jerseyDebounceRef.current) {
        clearTimeout(jerseyDebounceRef.current);
      }
    };
  }, [jerseyNumber, jerseyText, jerseyTextPosition, jerseyCurveText, activeTab]);

  // new function for upload
 /**
  * Laser-safe Jersey design generator
  * Directly replicates the UI positioning logic using the same calculations
  */
  async function createJerseyDesignForUpload(
   number,
   name,
   position = "below",
   curved = false
 ) {
   // Use larger dimensions for better quality after Cloudinary processing
   const width = 350, height = 400;
   
  console.log("➡️ Creating Jersey design with TTF font");

  try {
    // Load font from Cloudinary (guarantees TTF format - no auto-conversion)
    const fontUrl = "https://res.cloudinary.com/dgepygozk/raw/upload/v1763674796/Jersey_M54_z4zv8g.ttf";
    
    let font;
    try {
      font = await opentype.load(fontUrl);
      console.log('✅ Font loaded successfully from Cloudinary');
    } catch (fontError) {
      console.error('❌ Error loading font from Cloudinary:', fontError);
      // Fallback to Shopify CDN (may fail in incognito with WOFF2 issue)
      console.log('⚠️ Trying Shopify CDN as fallback...');
      const shopifyFontUrl = "https://cdn.shopify.com/s/files/1/0110/7827/1033/files/Jersey_M54.ttf?v=1758053820";
      font = await opentype.load(shopifyFontUrl);
    }
     
     // === REPLICATE EXACT UI POSITIONING LOGIC FROM createSVGJersey ===
     
     // 1. Number positioning (EXACT same as createSVGJersey)
     const tempDiv = document.createElement('div');
     tempDiv.style.position = 'absolute';
     tempDiv.style.visibility = 'hidden';
     tempDiv.style.fontFamily = 'Jersey M54, Arial, sans-serif';
     tempDiv.style.fontSize = '220px'; // Increased from 180px for larger etch
     tempDiv.style.fontWeight = 'bold';
     tempDiv.textContent = number;
     document.body.appendChild(tempDiv);
     
     const actualNumberHeight = tempDiv.offsetHeight;
     document.body.removeChild(tempDiv);
     
     const numberY = (height / 2) + (actualNumberHeight * 0.225);
     
     // 2. Text measurements (EXACT same as createSVGJersey)
     const tempTextDiv = document.createElement('div');
     tempTextDiv.style.position = 'absolute';
     tempTextDiv.style.visibility = 'hidden';
     tempTextDiv.style.fontFamily = 'Jersey M54, Arial, sans-serif';
     tempTextDiv.style.fontWeight = 'bold';
     tempTextDiv.textContent = name;
     document.body.appendChild(tempTextDiv);
     
     // Dynamic font sizing based on text length (EXACT same as createSVGJersey)
     const textLength = name.length;
     let textFontSize;
     if (textLength <= 4) {
       textFontSize = 90;
       tempTextDiv.style.fontSize = '90px';
     } else if (textLength <= 8) {
       textFontSize = 70;
       tempTextDiv.style.fontSize = '70px';
     } else if (textLength <= 12) {
       textFontSize = 50;
       tempTextDiv.style.fontSize = '50px';
     } else {
       textFontSize = 40;
       tempTextDiv.style.fontSize = '40px';
     }
     
     const actualTextHeight = tempTextDiv.offsetHeight;
     document.body.removeChild(tempTextDiv);
     
     // 3. Text positioning calculations (EXACT same as createSVGJersey)
     let textHeightPercent;
     if (textLength <= 4) {
       textHeightPercent = 0.25;
     } else if (textLength <= 8) {
       textHeightPercent = 0.20;
     } else if (textLength <= 12) {
       textHeightPercent = 0.14;
     } else {
       textHeightPercent = 0.11;
     }
     
     const actualTextHeightScaled = height * textHeightPercent;
     let gapPercent = 0.10; // Increased from 0.08 for larger number
     
     if (position === 'above') {
       gapPercent = 0.35; // Increased from 0.275 for larger number
      } 
      const gap = height * gapPercent;
     
     
     // Calculate textY using the EXACT same logic as UI createSVGJersey
     const textY = position === 'above' ? 
       numberY - (height * 0.55) : // Above: fixed position (same as UI)
       numberY + (height * 0.125); // Below: compensate for font size (same as UI)
     
     // 4. Curve calculations (EXACT same as createSVGJersey)
     const startX = width * 0.1;
     const endX = width * 0.9;
     const curveAmount = width * 0.10;
     
     // Calculate control point based on the actual curved line position (EXACT same as createSVGJersey)
     const curvedLineY = position === 'above' ? 
       textY + (actualTextHeightScaled * 0.2) : // Above: use textY as is
       textY + (actualTextHeightScaled * 0.55); // Below: same compensation as straight text
     
     const controlY = position === 'above' ? curvedLineY - curveAmount : curvedLineY + curveAmount;
     
     // === GENERATE PATHS WITH EXACT UI POSITIONING ===
     
     let paths = '';
     
     // Number path - use exact UI positioning with proper baseline
     const numberPath = font.getPath(number, 0, 0, 220); // Increased from 180px
     const numberBounds = numberPath.getBoundingBox();
     const numberWidth = numberBounds.x2 - numberBounds.x1;
     
     // Center horizontally like SVG text-anchor="middle"
     const numberX = (width / 2) - (numberWidth / 2) - numberBounds.x1;
     // Use baseline positioning like SVG text-baseline="middle" 
     const adjustedNumberY = numberY;  // Use numberY directly as baseline
     
     const centeredNumberPath = font.getPath(number, numberX, adjustedNumberY, 220); // Increased from 180px
     paths += `<path d="${centeredNumberPath.toPathData(2)}" fill="black" stroke="black" stroke-width="3" stroke-linejoin="round"/>`;
     
     // Text paths
     if (name && curved) {
       console.log("Creating curved text with natural character spacing");
       console.log("Curve positioning:", { curvedLineY, controlY, startX, endX });
       
       // === REPLICATE EXACT UI TEXTPATH SPACING ===
       // The UI uses SVG textPath which includes natural font advance widths (not just bounding box)
       // Let's measure the actual text width the same way the browser would
       
       // Create a temporary SVG to measure actual textPath spacing
       const tempSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
       tempSvg.style.position = 'absolute';
       tempSvg.style.visibility = 'hidden';
       tempSvg.setAttribute('width', '1000');
       tempSvg.setAttribute('height', '200');
       
       const tempText = document.createElementNS('http://www.w3.org/2000/svg', 'text');
       tempText.setAttribute('font-family', 'Jersey M54, Arial, sans-serif');
       tempText.setAttribute('font-size', textFontSize);
       tempText.setAttribute('font-weight', 'bold');
       tempText.textContent = name;
       
       tempSvg.appendChild(tempText);
       document.body.appendChild(tempSvg);
       
       // Get the actual rendered text width (includes natural font spacing)
       const actualTextWidth = tempText.getBBox().width;
       document.body.removeChild(tempSvg);
       
       console.log(`UI text measurement: "${name}" at ${textFontSize}px = ${actualTextWidth}px width`);
       
       // Calculate individual character widths for positioning
       const characterWidths = [];
       let totalCharacterWidth = 0;
       
       for (let i = 0; i < name.length; i++) {
         const char = name[i];
         const charPath = font.getPath(char, 0, 0, textFontSize);
         const charBounds = charPath.getBoundingBox();
         const charWidth = charBounds.x2 - charBounds.x1;
         characterWidths.push(charWidth);
         totalCharacterWidth += charWidth;
       }
       
       // Use the actual SVG text width (like the UI) instead of calculated width
       const totalTextWidth = actualTextWidth;
       
       // Calculate the difference to determine natural letter spacing
       const naturalSpacing = (actualTextWidth - totalCharacterWidth) / (name.length - 1);
       
       // Add additional letter spacing to match UI appearance
       const additionalSpacing = textFontSize * 0.18; // Increased from 12.5% to 18% for more spacing
       const totalLetterSpacing = naturalSpacing + additionalSpacing;
       
       console.log(`Natural letter spacing: ${naturalSpacing}px per character gap`);
       console.log(`Additional spacing: ${additionalSpacing}px per character gap`);
       console.log(`Total letter spacing: ${totalLetterSpacing}px per character gap`);
       
       // Recalculate total text width with additional spacing
       const totalTextWidthWithSpacing = totalCharacterWidth + (totalLetterSpacing * (name.length - 1));
       
       // Calculate curve length (approximate)
       const curveLength = Math.sqrt(
         Math.pow(endX - startX, 2) + 
         Math.pow(controlY - curvedLineY, 2)
       ) * 1.3; // Approximate quadratic Bézier length
       
       // Center the text on the curve (like startOffset="50%")
       const textStartOffset = (curveLength - totalTextWidthWithSpacing) / 2;
       
       console.log("Natural spacing:", { 
         totalTextWidth, 
         curveLength,
         textStartOffset,
         characterWidths 
       });
       
       // Position characters using cumulative widths with proper letter spacing
       let currentOffset = textStartOffset;
       
       for (let i = 0; i < name.length; i++) {
         const char = name[i];
         const charWidth = characterWidths[i];
         
         // Position character at its center point
         const charCenterOffset = currentOffset + (charWidth / 2);
         
         // Convert offset to curve parameter t
         const t = Math.max(0, Math.min(1, charCenterOffset / curveLength));
         
         // Calculate position on curve
         const x = (1 - t) ** 2 * startX + 2 * (1 - t) * t * (width/2) + t ** 2 * endX;
         const y = (1 - t) ** 2 * curvedLineY + 2 * (1 - t) * t * controlY + t ** 2 * curvedLineY;
         
         // Calculate tangent angle
         const dx = 2 * (1 - t) * (width/2 - startX) + 2 * t * (endX - width/2);
         const dy = 2 * (1 - t) * (controlY - curvedLineY) + 2 * t * (curvedLineY - controlY);
         const angle = Math.atan2(dy, dx) * (180 / Math.PI);
         
         // Position character centered on its position (like text-anchor="middle")
         const charX = -(charWidth / 2) - font.getPath(char, 0, 0, textFontSize).getBoundingBox().x1;
         const charY = 0;  // Use baseline like textPath
         
         const centeredCharPath = font.getPath(char, charX, charY, textFontSize);
         const d = centeredCharPath.toPathData(2);
         
         paths += `
           <g transform="translate(${x},${y}) rotate(${angle})">
             <path d="${d}" fill="black" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
           </g>`;
         
         // Advance to next character position with total spacing
         currentOffset += charWidth + totalLetterSpacing;
       }
     } else if (name) {
       // Straight text - use the same textY as curved text for consistency
       const straightLineY = position === "above" ? 
         textY + (actualTextHeightScaled * 0.2) : // Same as curvedLineY calculation
         textY + (actualTextHeightScaled * 0.55); // Same as curvedLineY calculation
       
       const textPath = font.getPath(name, 0, 0, textFontSize);
       const textBounds = textPath.getBoundingBox();
       const textWidth = textBounds.x2 - textBounds.x1;
       
       // Center horizontally like SVG text-anchor="middle"
       const textX = (width / 2) - (textWidth / 2) - textBounds.x1;
       // Use baseline positioning like SVG
       const adjustedTextY = straightLineY;
       
       const centeredTextPath = font.getPath(name, textX, adjustedTextY, textFontSize);
       paths += `<path d="${centeredTextPath.toPathData(2)}" fill="black" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>`;
     }
     
     const svg = `
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">
        <path d="M0,0 L0.001,0.001" />
        <path d="M${width},${height} L${width}.001,${height}.001" />
        ${paths}
       </svg>
     `;
    //  const svg = `
    //    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">
    //     ${paths}
    //    </svg>
    //  `;
     
     console.log("✅ Jersey SVG created with exact UI positioning");
     return svg;
     
   } catch (err) {
     console.error("❌ Error creating Jersey SVG:", err);
     
     // Provide user-friendly error message
     if (err.message && err.message.includes('wOF2')) {
       throw new Error('Font loading error. Please try again or use a different browser.');
     }
     
     throw err;
   }
 }

 // Helper function to analyze canvas and find text positions
 function findTextPositions(imageData, width, height) {
   const data = imageData.data;
   const positions = {
     number: null,
     text: null
   };
   
   // Simple approach: find the center of mass of dark pixels
   // This is a basic implementation - could be made more sophisticated
   let totalX = 0, totalY = 0, pixelCount = 0;
   let minX = width, maxX = 0, minY = height, maxY = 0;
   
   for (let y = 0; y < height; y++) {
     for (let x = 0; x < width; x++) {
       const index = (y * width + x) * 4;
       const r = data[index];
       const g = data[index + 1];
       const b = data[index + 2];
       const a = data[index + 3];
       
       // Check if pixel is dark (text)
       if (a > 128 && (r + g + b) < 384) { // Not white
         totalX += x;
         totalY += y;
         pixelCount++;
         
         minX = Math.min(minX, x);
         maxX = Math.max(maxX, x);
         minY = Math.min(minY, y);
         maxY = Math.max(maxY, y);
       }
     }
   }
   
   if (pixelCount > 0) {
     const centerX = totalX / pixelCount;
     const centerY = totalY / pixelCount;
     
     // Assume the larger text area is the number, smaller is the name
     const textHeight = maxY - minY;
     if (textHeight > 100) {
       positions.number = { x: centerX, y: centerY };
     } else {
       positions.text = { x: centerX, y: centerY, fontSize: Math.max(40, textHeight * 0.8) };
     }
   }
   
   return positions;
 }



  // Helper function to draw curved text on canvas using quadratic curve
  const drawCurvedText = (ctx, text, startX, endX, baseY, controlY) => {
    const characters = text.split('');
    
    // Calculate total text width with natural spacing
    const totalTextWidth = ctx.measureText(text).width;
    const startOffset = (endX - startX - totalTextWidth) / 2;
    
    let currentX = startX + startOffset;
    
    characters.forEach((char, index) => {
      const charWidth = ctx.measureText(char).width;
      const x = currentX + (charWidth / 2); // Center of character
      
      // Use linear distribution for symmetry (0 to 1) regardless of character widths
      const t = index / (characters.length - 1);
      
      // Calculate Y position using quadratic curve formula with proper control point
      // B(t) = (1-t)²P₀ + 2(1-t)tP₁ + t²P₂
      // Where P₀ = startY, P₁ = controlY, P₂ = endY
      const startY = baseY;
      const endY = baseY;
      const y = Math.pow(1 - t, 2) * startY + 2 * (1 - t) * t * controlY + Math.pow(t, 2) * endY;
      
      // Calculate the tangent angle at this point for character rotation
      // For quadratic curve: B'(t) = 2(1-t)(P₁-P₀) + 2t(P₂-P₁)
      // Simplified: B'(t) = 2(1-t)(controlY-startY) + 2t(endY-controlY)
      const dy = 2 * (1 - t) * (controlY - startY) + 2 * t * (endY - controlY);
      const dx = endX - startX; // Horizontal distance
      const angle = Math.atan2(dy, dx);
      
      // Save context state
      ctx.save();
      
      // Move to character position and rotate
      ctx.translate(x, y);
      ctx.rotate(angle);
      
      // Draw character at the curved position with rotation
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(char, 0, 0);
      
      // Restore context state
      ctx.restore();
      
      // Move to next character position with natural spacing
      currentX += charWidth;
    });
  };

  // Helper function to process the jersey canvas after font is loaded
  const processJerseyCanvas = (canvas, number, text, textPosition, baseWidth, baseHeight) => {
    const ctx = canvas.getContext('2d');
    
    try {
      // Get image data for processing - use the actual canvas dimensions (scaled)
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      
      console.log('Processing jersey image data, pixels:', data.length / 4);
      
      // Apply metallic effect to text pixels with better detection
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        
        // More precise text detection - look for dark pixels with sufficient opacity
        // This helps preserve crisp edges and avoid including anti-aliased artifacts
        const isTextPixel = a > 50 && (r + g + b) < 200; // More restrictive than before
        
        if (isTextPixel) {
          // Calculate position for metallic effect - use actual canvas dimensions
          const x = (i / 4) % canvas.width / canvas.width;
          const y = Math.floor((i / 4) / canvas.width) / canvas.height;
          
          // Create metallic silver with directional sheen
          const t = (Math.sin(x * Math.PI * 2) * 0.5 + 0.5) * 0.8 + 0.1;
          const metallicR = Math.round(130 * (1 - t) + 248 * t);
          const metallicG = Math.round(135 * (1 - t) + 249 * t);
          const metallicB = Math.round(140 * (1 - t) + 252 * t);
          
          data[i] = metallicR;
          data[i + 1] = metallicG;
          data[i + 2] = metallicB;
          data[i + 3] = 255; // Keep fully opaque
        } else {
          // Make background transparent
          data[i + 3] = 0;
        }
      }
      
      // Add subtle noise for brushed metal effect
      const noiseAmount = 1; // Reduced noise for text
      for (let i = 0; i < data.length; i += 4) {
        if (data[i + 3] === 255) {
          const n = (Math.random() - 0.5) * noiseAmount;
          data[i] = Math.max(0, Math.min(255, data[i] + n));
          data[i + 1] = Math.max(0, Math.min(255, data[i + 1] + n));
          data[i + 2] = Math.max(0, Math.min(255, data[i + 2] + n));
        }
      }
      
      // Put the processed image data back
      ctx.putImageData(imageData, 0, 0);
      
      console.log('Metallic effect applied, converting to blob...');
      
      // Convert to blob and create URL
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error('Failed to create blob from canvas');
          return;
        }
        
        console.log('Blob created:', blob.size, 'bytes');
        const metallicJerseyUrl = URL.createObjectURL(blob);
        console.log('Metallic jersey URL created:', metallicJerseyUrl);
        
        // Get dynamic styles based on selected product and text length
        const productType = selectedProduct?.collectionHandle || 'traveler-40oz';
        const totalTextLength = (number + text).length;
        const styles = getCustomElementStyles(productType, 'text', totalTextLength);
        
        // Create the jersey element with the metallic image
        const newElement = {
          type: 'image',
          imageUrl: metallicJerseyUrl,
          width: styles.width,
          height: styles.height,
          top: styles.top,
          left: styles.left,
          right: styles.right,
          margin: styles.margin,
          rotation: 0,
          isPresetDesign: false,
          textLength: totalTextLength
        };
        
        console.log('New metallic jersey element created:', newElement);
        
        // Replace all existing elements with the new metallic jersey element
        setCustomElements([newElement]);
        console.log("Added metallic jersey element:", newElement);
      }, 'image/png');
      
    } catch (error) {
      console.error("Error processing jersey canvas:", error);
      
      // Fallback to regular text if metallic processing fails
      const newElement = {
        type: 'text',
        text: `${number} ${text}`.trim(),
        fontSize: 24,
        color: '#000000',
        fontFamily: 'Jersey M54',
        rotation: 0,
        isPresetDesign: false,
        textLength: (number + text).length
      };
      
      setCustomElements([newElement]);
      console.log("Fallback jersey element created:", newElement);
    }
  };

  // const updateElement = (index, updatedElement) => {
  //   console.log("Updating element:", index, updatedElement);
  //   setCustomElements(prev => 
  //     prev.map((element, i) => onElementUpdate
  //   );
  // };

  // const deleteSelectedElement = () => {
  //   console.log("Deleting element");
  //   setCustomElements([]);
  //   setSelectedElement(null);
  // };

  const rotateElementLeft = () => {
    if (customElements.length > 0) {
      const currentElement = customElements[0];
      const currentRotation = currentElement.rotation || 0;
      // Rotate left: 0 → 270, 90 → 0, 180 → 90, 270 → 180
      let newRotation = currentRotation - 90;
      if (newRotation < 0) newRotation = 270; // Wrap to 270 if going below 0
      
      console.log(`Rotating element left: ${currentRotation}° → ${newRotation}°`);
      
      setCustomElements(prev => 
        prev.map((element, index) => 
          index === 0 
            ? { ...element, rotation: newRotation }
            : element
        )
      );
    }
  };

  const rotateElementRight = () => {
    if (customElements.length > 0) {
      const currentElement = customElements[0];
      const currentRotation = currentElement.rotation || 0;
      // Rotate right: 0 → 90, 90 → 180, 180 → 270, 270 → 0
      let newRotation = currentRotation + 90;
      if (newRotation >= 360) newRotation = 0; // Wrap to 0 if going above 270
      
      console.log(`Rotating element right: ${currentRotation}° → ${newRotation}°`);
      
      setCustomElements(prev => 
        prev.map((element, index) => 
          index === 0 
            ? { ...element, rotation: newRotation }
            : element
        )
      );
    }
  };

  const resetSelections = () => {
    setSelectedProduct(null);
    setSelectedColor(null);
    setProductImageUrl(null);
    setCustomElements([]);
    // setSelectedElement(null); // Commented out for static positioning
    setCustomText("");
    setSelectedFont("Arial");

    // Reset jersey state
    setJerseyNumber("");
    setJerseyText("");
    setJerseyTextPosition("below");
    setJerseyCurveText(false);
    
    // Reset preset design state
    setSelectedPresetDesign(null);
    setSelectedPresetCategory(null);

    setActiveTab("text");
    setIsDrawerOpen(false);
    // Reset logo processing state
    setLogoProcessingState('idle');
    setProcessedLogoUrl(null);
    setOriginalLogoUrl(null);
    setProcessingProgress(0);
    setThresholdValue(128);
    setInvertEtch(false);
  };

  // Check if current design requires terms acceptance
  const requiresTermsAcceptance = () => {
    console.log('🔍 Checking terms acceptance:', {
      activeTab,
      jerseyNumber,
      jerseyText,
      customText: `"${customText}"`,
      customElementsLength: customElements.length,
      customElements: customElements.map(el => ({ type: el.type, id: el.id }))
    });
    
    // Check if user has jersey design
    if (activeTab === 'jersey' && (jerseyNumber?.trim() || jerseyText?.trim())) {
      console.log('✅ Jersey design detected - requires terms');
      return true;
    }
    
    // Check if user has custom text
    if (activeTab === 'text' && customText?.trim()) {
      console.log('✅ Custom text detected - requires terms');
      return true;
    }
    
    // Check if user has uploaded logo
    if (activeTab === 'upload' && customElements.length > 0) {
      console.log('✅ Upload logo detected - requires terms');
      return true;
    }
    
    // Also check if we have any custom elements regardless of tab (fallback)
    if (customElements.length > 0) {
      console.log('✅ Custom elements detected - requires terms');
      return true;
    }
    
    console.log('❌ No custom designs detected - no terms required');
    return false;
  };

  // Handle terms modal for Add to Cart
  const handleAddToCartWithTerms = () => {
    console.log('=== handleAddToCartWithTerms called ===');
    console.log('Current state:', {
      activeTab,
      customText,
      jerseyNumber,
      jerseyText,
      customElementsLength: customElements.length,
      showTermsModal
    });
    
    const needsTerms = requiresTermsAcceptance();
    console.log('Needs terms:', needsTerms);
    
    if (needsTerms) {
      console.log('✅ SHOULD SHOW MODAL - Setting showTermsModal to true');
      setShowTermsModal(true);
      setTermsAccepted(false);
      console.log('Modal state set, should render now');
    } else {
      console.log('❌ NO MODAL NEEDED - Proceeding directly to cart');
      // Proceed directly to cart if no custom designs
      handleAddToCart();
    }
    console.log('=== End handleAddToCartWithTerms ===');
  };

  const handleTermsAccept = () => {
    setShowTermsModal(false);
    setTermsAccepted(false);
    // Proceed with the original Add to Cart function
    handleAddToCart();
  };

  const handleTermsCancel = () => {
    setShowTermsModal(false);
    setTermsAccepted(false);
  };


  // Deprecated local cart builder - superseded by handleAddToCart above
  // const handleAddToCart = () => {}

  // Function to process preset design with metallic effect
  const processPresetDesignWithMetallic = async (imageUrl, options = {}) => {
    const { storeBaseCanvas = false } = options;
    try {
      console.log('Processing preset design with metallic effect:', imageUrl);
      
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      return new Promise((resolve, reject) => {
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          
          // Use high resolution for crisp results (4x scale)
          const scale = 4;
          const baseWidth = img.width;
          const baseHeight = img.height;
          
          // Set canvas size with ultra-high resolution
          canvas.width = baseWidth * scale;
          canvas.height = baseHeight * scale;
          
          // Scale the context for ultra-high resolution
          ctx.scale(scale, scale);
          
          // Enable high-quality image rendering
          ctx.imageSmoothingEnabled = false;
          
          // Draw the original image
          ctx.drawImage(img, 0, 0, baseWidth, baseHeight);
          
          // Store base canvas BEFORE applying metallic effect (for fast color updates)
          if (storeBaseCanvas) {
            const baseCanvas = document.createElement('canvas');
            baseCanvas.width = canvas.width;
            baseCanvas.height = canvas.height;
            const baseCtx = baseCanvas.getContext('2d');
            baseCtx.drawImage(canvas, 0, 0);
            presetDesignCanvasRef.current = baseCanvas;
            console.log('💾 Stored base canvas for preset design:', baseCanvas.width, 'x', baseCanvas.height);
          }
          
          // Get image data for processing
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;
          
          console.log('Processing preset design image data, pixels:', data.length / 4);
          
          // Apply metallic effect to non-transparent pixels
          for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];
            
            // Check if this pixel has content (not transparent)
            if (a > 0) {
              // Calculate position for metallic effect
              const x = (i / 4) % canvas.width / canvas.width;
              const y = Math.floor((i / 4) / canvas.width) / canvas.height;
              
              // Check if selected jug has bronze-etch tag
              const isBronzeEtchValue = isBronzeEtch();
              
              // Create metallic effect - bronze or silver based on jug tag (centered gradient like Jersey)
              const distanceFromCenter = Math.abs(x - 0.5) * 2; // 0 at center, 1 at edges
              const t = (1 - distanceFromCenter) * 0.8 + 0.1; // Light in center, darker at edges
              
              let metallicR, metallicG, metallicB;
              if (isBronzeEtchValue) {
                // Bronze metallic effect - balanced bronze-gold with even lighter base
                const bronzeBase = { r: 155, g: 120, b: 85 }; // Even lighter bronze-gold base
                const bronzeHighlight = { r: 230, g: 190, b: 130 }; // Balanced bronze-gold highlight
                metallicR = Math.round(bronzeBase.r * (1 - t) + bronzeHighlight.r * t);
                metallicG = Math.round(bronzeBase.g * (1 - t) + bronzeHighlight.g * t);
                metallicB = Math.round(bronzeBase.b * (1 - t) + bronzeHighlight.b * t);
              } else {
                // Silver metallic effect (original)
                metallicR = Math.round(130 * (1 - t) + 248 * t);
                metallicG = Math.round(135 * (1 - t) + 249 * t);
                metallicB = Math.round(140 * (1 - t) + 252 * t);
              }
              
              data[i] = metallicR;
              data[i + 1] = metallicG;
              data[i + 2] = metallicB;
              data[i + 3] = a; // Keep original alpha
            }
          }
          
          // Add subtle noise for brushed metal effect
          const noiseAmount = 1;
          for (let i = 0; i < data.length; i += 4) {
            if (data[i + 3] > 0) {
              const n = (Math.random() - 0.5) * noiseAmount;
              data[i] = Math.max(0, Math.min(255, data[i] + n));
              data[i + 1] = Math.max(0, Math.min(255, data[i + 1] + n));
              data[i + 2] = Math.max(0, Math.min(255, data[i + 2] + n));
            }
          }
          
          // Put the processed image data back
          ctx.putImageData(imageData, 0, 0);
          
          console.log('Metallic effect applied to preset design, converting to blob...');
          
          // Convert to blob and create URL
          canvas.toBlob((blob) => {
            if (blob) {
              const metallicUrl = URL.createObjectURL(blob);
              console.log('Metallic preset design URL created:', metallicUrl);
              resolve(metallicUrl);
            } else {
              reject(new Error('Failed to create blob from canvas'));
            }
          }, 'image/png');
        };
        
        img.onerror = reject;
        img.src = imageUrl;
      });
      
    } catch (error) {
      console.error('Error processing preset design with metallic effect:', error);
      throw error;
    }
  };

  return (
    <CustomizerContainer className="hydrojug-customizer-main">
      <GlobalScrollLock />
      <SpinnerStyle />
      <CanvasSection className="customizer-canvas-section">

        
        <CanvasWrapper className="customizer-canvas-wrapper">
          {productImageUrl ? (
          <ProductCanvas
            productImageUrl={productImageUrl}
            customElements={customElements}
            // selectedElement={selectedElement} // Commented out for static positioning
            // onElementSelect={setSelectedElement} // Commented out for static positioning
            // onElementUpdate={updateElement} // Commented out for static positioning
          />
          ) : (
            <InstructionsComponent />
          )}
        </CanvasWrapper>
        
        {customElements.length > 0 && activeTab !== 'jersey' && (
          <div 
            className="customizer-rotation-controls customizer-rotation-controls--mobile"
            style={{ 
              marginTop: '1rem', 
              display: 'flex', 
              gap: '0.5rem'
            }}
          >
            {/* <Button onClick={deleteSelectedElement} style={{ background: '#ef4444' }}>
              Delete Element
            </Button> */}
            <Button 
              className="customizer-rotate-button customizer-rotate-left"
              onClick={rotateElementLeft} 
              style={{ background: '#3b82f6', padding: "10.4px 28px" }}
            >
              Rotate Left
            </Button>
            <Button 
              className="customizer-rotate-button customizer-rotate-right"
              onClick={rotateElementRight} 
              style={{ background: '#3b82f6', padding: "10.4px 28px" }}
            >
              Rotate Right
            </Button>
          </div>
        )}
        
        
      </CanvasSection>

      <ControlsSection className="customizer-controls-section">
        {/* Header */}
        <div 
          className="customizer-controls-header customizer-controls-header--mobile"
          style={{ 
            padding: '1rem 12px', 
            borderBottom: '1px solid #e5e7eb',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <h2 style={{ 
            fontSize: '1rem', 
            fontWeight: '600', 
            color: '#374151',
            margin: 0
          }}>
            {selectedProduct ? selectedProduct.productType.toUpperCase() : 'SELECT PRODUCT'} {selectedColor ? `- ${selectedColor.title.toUpperCase()}` : ''}
          </h2>
          <ResetButton 
            onClick={resetSelections}
            style={{
              fontSize: '0.75rem',
              fontWeight: '500'
            }}
          >
            Reset
          </ResetButton>
        </div>

        {/* Product Selection */}
        <StepContainer className="customizer-step-container customizer-product-selection">
          <StepTitle className="customizer-step-title">SELECT PRODUCT TYPE</StepTitle>
          {loading ? (
            <div>Loading products...</div>
          ) : (
            <ProductGrid className="customizer-product-grid">
              {collections.map((collection) => (
                <ProductCard
                  key={collection.handle}
                  className={`customizer-product-card customizer-product-card-${collection.handle}`}
                  $selected={selectedProduct?.collectionHandle === collection.handle}
                  onClick={() => {
                    // Remove any scroll lock that may have been incorrectly added
                    document.body.classList.remove('ps-scroll-lock');
                    document.documentElement.classList.remove('ps-scroll-lock');
                    
                    const newProduct = {
                      ...collection.products[0],
                      collectionHandle: collection.handle,
                      allProducts: collection.products
                    };
                    
                    setSelectedProduct(newProduct);
                    
                    // If we have a currently selected color, try to find it in the new product
                    if (selectedColor) {
                      const matchingColor = newProduct.allProducts.find(product => 
                        product.title === selectedColor.title
                      );
                      
                      if (matchingColor) {
                        setSelectedColor(matchingColor);
                      } else {
                        // If no matching color found, select the first available color
                        setSelectedColor(newProduct.allProducts[0]);
                      }
                    } else {
                      // If no color was previously selected, select the first available color
                      setSelectedColor(newProduct.allProducts[0]);
                    }
                  }}
                >
                  <img 
                    src={collection.products[0]?.variants[0]?.featured_image?.src} 
                    alt={collection.title}
                    style={{
                      filter: 'brightness(0) saturate(100%)'
                    }}
                  />
                  <span>{collection.title}</span>
                </ProductCard>
              ))}
            </ProductGrid>
          )}
        </StepContainer>

        {/* Color Selection - Only show when product is selected */}
        {selectedProduct && (
          <StepContainer className="customizer-step-container customizer-color-selection">
            <div className="customizer-color-header" style={{ marginBottom: '0.5rem' }}>
              <span className="customizer-color-label" style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                COLOR: {selectedColor?.title || 'Select a color'}
              </span>
            </div>
            <ColorGrid className="customizer-color-grid">
              {selectedProduct.allProducts?.map((product) => {
                const colorPattern = getColorPattern(product);
                
                // Use image if available, otherwise use hex color
                const hasImage = colorPattern?.image && colorPattern.image !== 'null' && colorPattern.image !== '';
                const hexColor = colorPattern?.color;
                
                return (
                  <ColorCard
                    key={product.id}
                    className={`customizer-color-card customizer-color-card-${product.id}`}
                    $selected={selectedColor?.id === product.id}
                    onClick={() => {
                      // Remove any scroll lock that may have been incorrectly added
                      document.body.classList.remove('ps-scroll-lock');
                      document.documentElement.classList.remove('ps-scroll-lock');
                      
                      setSelectedColor(product);
                    }}
                    title={product.title}
                    style={{
                      background: hasImage ? 'transparent' : (hexColor || '#cccccc'),
                      backgroundImage: hasImage ? `url(${colorPattern.image})` : 'none',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}
                  >
                    {!hasImage && !hexColor && (
                      <div style={{ 
                        width: '100%', 
                        height: '100%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        fontSize: '10px',
                        color: '#666'
                      }}>
                        ?
                      </div>
                    )}
                  </ColorCard>
                );
              })}
            </ColorGrid>
          </StepContainer>
        )}

        {/* Design Selection */}
        {selectedColor && (
          <StepContainer className="customizer-step-container customizer-design-selection">
            {/* Customization Options */}
            <div className="customizer-options-container" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <CustomizationCard 
                className="customizer-option-card customizer-option-upload-logo"
                onClick={() => {
                  setActiveTab('upload');
                  setIsDrawerOpen(true);
                }}
              >
                <div className="icon customizer-option-icon">
                  <img src="https://cdn.shopify.com/s/files/1/0110/7827/1033/files/customizer-upload-icon.png?v=1759423083" alt="Upload Logo" />
                </div>
                <div className="content customizer-option-content">
                  <div className="title customizer-option-title">UPLOAD LOGO</div>
                  {/* <div className="subtitle customizer-option-subtitle">Upload your own logo</div> */}
                  <div className="price customizer-option-price">$12.99</div>
                </div>
                <div className="arrow customizer-option-arrow">→</div>
              </CustomizationCard>
              
              <CustomizationCard 
                className="customizer-option-card customizer-option-custom-text"
                onClick={() => {
                  setActiveTab('text');
                  setIsDrawerOpen(true);
                }}
              >
                <div className="icon customizer-option-icon">
                  <img src="https://cdn.shopify.com/s/files/1/0110/7827/1033/files/customizer-text-icon.png?v=1759423083" alt="Custom Text" />
                </div>
                <div className="content customizer-option-content">
                  <div className="title customizer-option-title">CUSTOM TEXT</div>
                  {/* <div className="subtitle customizer-option-subtitle">Add custom text</div> */}
                  <div className="price customizer-option-price">$9.99</div>
                </div>
                <div className="arrow customizer-option-arrow">→</div>
              </CustomizationCard>
              
              <CustomizationCard 
                className="customizer-option-card customizer-option-jersey"
                onClick={() => {
                  setActiveTab('jersey');
                  setIsDrawerOpen(true);
                }}
              >
                <div className="icon customizer-option-icon">
                  <img src="https://cdn.shopify.com/s/files/1/0110/7827/1033/files/customizer-jersey-icon.png?v=1759423083" alt="Jersey Style" />
                </div>
                <div className="content customizer-option-content">
                  <div className="title customizer-option-title">JERSEY STYLE</div>
                  {/* <div className="subtitle customizer-option-subtitle">Numbers and text like a jersey</div> */}
                  <div className="price customizer-option-price">$9.99</div>
                </div>
                <div className="arrow customizer-option-arrow">→</div>
              </CustomizationCard>
              
              <CustomizationCard 
                className="customizer-option-card customizer-option-preset-designs"
                onClick={() => {
                  setActiveTab('preset');
                  setIsDrawerOpen(true);
                }}
              >
                <div className="icon customizer-option-icon">
                  <img src="https://cdn.shopify.com/s/files/1/0110/7827/1033/files/hydro-favicon.svg?v=1737736269" alt="Gallery" />
                </div>
                <div className="content customizer-option-content">
                  <div className="title customizer-option-title">GALLERY</div>
                  {/* <div className="subtitle customizer-option-subtitle">Choose from our designs</div> */}
                  <div className="price customizer-option-price">$9.99</div>
                </div>
                <div className="arrow customizer-option-arrow">→</div>
              </CustomizationCard>
            </div>
          </StepContainer>
        )}

        {/* Add to Cart Button - Only show when all requirements are met */}
        {selectedProduct && selectedColor && (
          customElements.length > 0 || 
          (activeTab === 'text' && customText) || 
          (activeTab === 'jersey' && (jerseyNumber || jerseyText)) ||
          (activeTab === 'preset' && selectedPresetDesign)
        ) && (
          <StepContainer className="customizer-step-container customizer-add-to-cart-section">
            {/* <StepTitle className="customizer-step-title">READY TO ORDER</StepTitle> */}
            <div className="customizer-add-to-cart-container" style={{ textAlign: 'center' }}>
              <p className="customizer-add-to-cart-description" style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '1rem' }}>
                Your custom design is ready! Click below to add to cart.
              </p>
              <Button 
                className="customizer-add-to-cart-button"
                onClick={handleAddToCartWithTerms}
                disabled={addingToCart || logoProcessingState === 'processing' || logoProcessingState === 'threshold'}
                style={{ 
                  background: addingToCart || logoProcessingState === 'processing' || logoProcessingState === 'threshold' ? '#9ca3af' : '#10b981',
                  color: 'white',
                  padding: '0.75rem 2rem',
                  fontSize: '1rem',
                  fontWeight: '600',
                  borderRadius: '0.5rem',
                  border: 'none',
                  cursor: addingToCart || logoProcessingState === 'processing' || logoProcessingState === 'threshold' ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                {logoProcessingState === 'processing' || logoProcessingState === 'threshold' ? '⏳ Processing...' : 
                 'Add to Cart'}
              </Button>
              
              {/* Temporary test button for debugging */}
              {/* <Button 
                onClick={() => {
                  console.log('Test button clicked - forcing modal');
                  setShowTermsModal(true);
                  setTermsAccepted(false);
                }}
                style={{ 
                  background: '#ff6b6b',
                  color: 'white',
                  padding: '0.5rem 1rem',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  borderRadius: '0.25rem',
                  border: 'none',
                  cursor: 'pointer',
                  marginTop: '0.5rem'
                }}
              >
                Test Modal
              </Button> */}
            </div>
          </StepContainer>
        )}

        {/* Slide Drawer */}
        <Overlay 
          $isOpen={isDrawerOpen} 
          onClick={() => setIsDrawerOpen(false)}
        />
        
        <SlideDrawer 
          ref={drawerRef}
          className="customizer-slide-drawer"
          $isOpen={isDrawerOpen}
        >
          <DrawerHeader className="customizer-drawer-header">
            <BackButton 
              className="customizer-back-button"
              onClick={() => setIsDrawerOpen(false)}
            >
              ← Back
            </BackButton>
            <h3 
              className="customizer-drawer-title"
              style={{ 
                fontSize: '1rem', 
                fontWeight: '600', 
                color: '#374151',
                margin: 0
              }}
            >
              {activeTab === 'upload' ? 'UPLOAD LOGO' : 
               activeTab === 'text' ? 'CUSTOM TEXT' :
               activeTab === 'jersey' ? 'JERSEY STYLE' :
               activeTab === 'preset' ? 'PRESET DESIGNS' : 'CUSTOMIZE'}
            </h3>
            <div className="customizer-drawer-spacer" style={{ width: '60px' }}></div> {/* Spacer for centering */}
          </DrawerHeader>
          
          <DrawerContent 
            className="customizer-drawer-content"
          >
            {activeTab === 'upload' && (
              <div className="customizer-upload-section">
                {/* Logo Upload Section */}
                <UploadGuidelines>
                  {/* <GuidelinesHeader>
                    <div className="icon">📋</div>
                    <div className="title">Upload Requirements</div>
                  </GuidelinesHeader> */}
                  
                  <GuidelinesList>
                    <GuidelineItem>
                      <div className="icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                          <path d="M9 9h6v6H9z"/>
                        </svg>
                      </div>
                      <div className="text">
                        <span className="size-requirement">Image must be 300px (W or H)</span><br/>
                        Minimum size requirement for quality
                      </div>
                    </GuidelineItem>
                    
                    <GuidelineItem>
                      <div className="icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                          <circle cx="8.5" cy="8.5" r="1.5"/>
                          <polyline points="21,15 16,10 5,21"/>
                        </svg>
                      </div>
                      <div className="text">
                        <span className="size-requirement">No photographs</span><br/>
                        Use logos, graphics, or artwork only
                      </div>
                    </GuidelineItem>
                    
                    <GuidelineItem>
                      <div className="icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
                          <circle cx="12" cy="12" r="10"/>
                          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
                        </svg>
                      </div>
                      <div className="text">
                        <span className="size-requirement">No copyright infringement</span><br/>
                        Only upload content you own or have permission to use
                      </div>
                    </GuidelineItem>
                    
                    <GuidelineItem>
                      <div className="icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
                          <path d="M10 2v20M14 2v20M4 7h16M4 17h16"/>
                        </svg>
                      </div>
                      <div className="text">
                        <span className="size-requirement">No trademark infringement</span><br/>
                        Avoid using protected brand names, logos, or symbols
                      </div>
                    </GuidelineItem>
                  </GuidelinesList>
                </UploadGuidelines>

                                {/* Fallback Processing Button */}
                                {logoProcessingState === 'error' && originalLogoUrl && (
                  <div style={{ marginTop: '1rem' }}>
                    <p style={{ fontSize: '0.75rem', color: '#6b7280', marginBottom: '0.5rem' }}>
                      Cloudinary processing failed. Try local processing instead:
                    </p>
                    <Button 
                      onClick={() => processImageLocally(originalLogoUrl, { preview: true })}
                      style={{ background: '#10b981' }}
                    >
                      Process Locally
                    </Button>
                  </div>
                )}

                {/* Processing State */}
                {logoProcessingState === 'processing' && (
                  <ProcessingContainer className="customizer-processing-container">
                    <div className="customizer-processing-status" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                      <div className="customizer-processing-spinner" style={{ width: '16px', height: '16px', border: '2px solid #3b82f6', borderTop: '2px solid transparent', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                      <span className="customizer-processing-text" style={{ fontSize: '0.875rem', color: '#374151' }}>Processing logo for etching...</span>
                    </div>
                    <ProgressBar className="customizer-progress-bar">
                      <ProgressFill className="customizer-progress-fill" progress={processingProgress} />
                    </ProgressBar>
                    <p className="customizer-processing-description" style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.5rem' }}>
                      Removing background, converting to black & white, and creating SVG for etching
                    </p>
                  </ProcessingContainer>
                )}

                {/* Processed Logo - Show small preview with button to review */}
                {logoProcessingState === 'processed' && !showReviewModal && (
                  <ProcessingContainer className="customizer-processed-container">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                      {processedLogoUrl && (
                        <img 
                          src={processedLogoUrl} 
                          alt="Processed logo" 
                          style={{ 
                            width: '60px', 
                            height: '60px', 
                            objectFit: 'contain',
                            border: '1px solid #e2e8f0',
                            borderRadius: '0.25rem',
                            background: 'white'
                          }} 
                        />
                      )}
                      <div style={{ flex: 1 }}>
                        <p style={{ margin: 0, fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>
                          Logo processed
                        </p>
                        <button
                          onClick={() => setShowReviewModal(true)}
                          style={{
                            marginTop: '0.25rem',
                            padding: 0,
                            background: 'none',
                            border: 'none',
                            color: '#3b82f6',
                            fontSize: '0.8125rem',
                            cursor: 'pointer',
                            textDecoration: 'underline'
                          }}
                        >
                          Review & adjust
                        </button>
                      </div>
                    </div>
                  </ProcessingContainer>
                )}

                {/* Error State */}
                {logoProcessingState === 'error' && (
                  <ErrorMessage>
                    <strong>Processing Error:</strong> There was an issue processing your logo. Please try uploading a different image or contact support.
                  </ErrorMessage>
                )}
                <UploadLabel 
                  className="customizer-upload-label"
                  htmlFor="logo-upload"
                >
                  Click to upload logo
                  <UploadButton
                    id="logo-upload"
                    className="customizer-upload-button"
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    disabled={logoProcessingState === 'processing'}
                  />
                </UploadLabel>
                <p style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '0.5rem' }}>
                  Supported formats: PNG, JPG, SVG (recommended for best quality)
                </p>
                
                {/* Upload Guidelines */}

                

                

                
              </div>
            )}

            {activeTab === 'text' && (
              <div className="customizer-text-section">
                {/* Text Input */}
                <div className="customizer-text-input-container" style={{ marginBottom: '1.5rem' }}>
                  <label className="customizer-text-input-label" style={{ 
                    display: 'block', 
                    fontSize: '0.875rem', 
                    fontWeight: '600', 
                    color: '#374151', 
                    marginBottom: '0.5rem' 
                  }}>
                    Enter Your Text
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter your custom text"
                    value={customText}
                    onChange={(e) => {
                      // Allow letters, numbers, spaces, and common special characters
                      const value = e.target.value.replace(/[^a-zA-Z0-9 !?+\-&@#$%'".,:;]/g, '');
                      setCustomText(value);
                    }}
                    maxLength={15}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem',
                      fontSize: '1rem',
                      marginBottom: '0.5rem'
                    }}
                  />
                  <p className="customizer-text-input-help" style={{ 
                    fontSize: '0.75rem', 
                    color: '#6b7280', 
                    margin: 0 
                  }}>
                    Maximum 15 characters
                  </p>
                </div>



                {/* Font Preview Grid */}
                {customText.trim() && (
                  <div className="customizer-font-preview-container" style={{ marginBottom: '1.5rem' }}>
                    <label className="customizer-font-preview-label" style={{ 
                      display: 'block', 
                      fontSize: '0.875rem', 
                      fontWeight: '600', 
                      color: '#374151', 
                      marginBottom: '0.75rem' 
                    }}>
                      Choose Font Style
                    </label>
                    <div className="customizer-font-grid" style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                      gap: '0.75rem' 
                    }}>
                      {fonts.map((font) => (
                        <FontCard
                          key={font.value}
                          className={`font-card-${font.value}`}
                          $selected={selectedFont === font.value}
                          onClick={() => {
                            console.log('Font clicked:', font.value, 'Currently selected:', selectedFont, 'Is selected:', selectedFont === font.value);
                            setSelectedFont(font.value);
                            // Auto-create text design when font is selected
                            if (customText.trim()) {
                              const canvasWidth = window.innerWidth <= 768 ? 400 : 600;
                              const canvasHeight = window.innerWidth <= 768 ? 400 : 600;
                              createMetallicText(customText, font.value, canvasWidth, canvasHeight);
                              setIsDrawerOpen(false);
                            }
                          }}
                        >
                          <div 
                            className="customizer-font-preview-text"
                            style={{
                              fontFamily: font.value,
                              fontSize: '24px',
                              fontWeight: font.value === 'Montserrat' ? '600' : '400',
                              color: '#374151',
                              marginBottom: '0.5rem',
                              lineHeight: '1.2',
                              minHeight: '2.5rem',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              lineBreak: 'anywhere',
                            }}
                          >
                            {customText}
                          </div>
                          <div 
                            className="customizer-font-preview-name"
                            style={{
                              fontSize: '0.75rem',
                              color: '#6b7280',
                              fontWeight: '500'
                            }}
                          >
                            {font.name}
                          </div>
                        </FontCard>
                      ))}
                    </div>
                  </div>
                )}

              </div>
            )}

            {activeTab === 'jersey' && (
              <div className="customizer-jersey-section">
                {/* Jersey Number Input */}
                <div className="customizer-jersey-numbers" style={{ marginBottom: '1rem' }}>
                  <label className="customizer-jersey-label" style={{ 
                    display: 'block', 
                    fontSize: '0.875rem', 
                    fontWeight: '600', 
                    color: '#374151', 
                    marginBottom: '0.75rem' 
                  }}>
                    Jersey Number
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter jersey number"
                    value={jerseyNumber}
                    onChange={(e) => {
                      // Only allow numbers
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setJerseyNumber(value);
                    }}
                    maxLength={2}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem',
                      fontSize: '1rem',
                      textAlign: 'center'
                    }}
                  />
                </div>

                {/* Jersey Text Input */}
                <div className="customizer-jersey-text" style={{ marginBottom: '1rem' }}>
                  <label className="customizer-jersey-label" style={{ 
                    display: 'block', 
                    fontSize: '0.875rem', 
                    fontWeight: '600', 
                    color: '#374151', 
                    marginBottom: '0.5rem' 
                  }}>
                    Jersey Text
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter jersey text (e.g., team name)"
                    value={jerseyText}
                    onChange={(e) => {
                      // Only allow letters (a-z, A-Z) and hyphens (-)
                      const value = e.target.value.replace(/[^a-zA-Z\-]/g, '');
                      setJerseyText(value.toUpperCase());
                    }}
                    maxLength={12}
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem',
                      fontSize: '1rem',
                      textTransform: 'uppercase'
                    }}
                  />
                </div>

                {/* Text Position Selection */}
                <div className="customizer-jersey-position" style={{ marginBottom: '1.5rem' }}>
                  <label className="customizer-jersey-label" style={{ 
                    display: 'block', 
                    fontSize: '0.875rem', 
                    fontWeight: '600', 
                    color: '#374151', 
                    marginBottom: '0.5rem' 
                  }}>
                    Text Position
                  </label>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Button
                      onClick={() => setJerseyTextPosition('above')}
                      style={{
                        flex: 1,
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem',
                        fontSize: '1rem',
                        background: jerseyTextPosition === 'above' ? '#10b981' : 'white',
                        color: jerseyTextPosition === 'above' ? 'white' : '#374151',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      Above Number
                    </Button>
                    <Button
                      onClick={() => setJerseyTextPosition('below')}
                      style={{
                        flex: 1,
                        padding: '0.75rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '0.375rem',
                        fontSize: '1rem',
                        background: jerseyTextPosition === 'below' ? '#10b981' : 'white',
                        color: jerseyTextPosition === 'below' ? 'white' : '#374151',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      Below Number
                    </Button>
                  </div>
                </div>

                {/* Curve Text Toggle */}
                <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
                  <label style={{ fontSize: '0.875rem', fontWeight: '600', color: '#374151', marginBottom: '0.5rem', display: 'block' }}>
                    Curved Text
                  </label>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                    <button
                      type="button"
                      onClick={() => setJerseyCurveText(!jerseyCurveText)}
                      style={{
                        width: '44px',
                        height: '24px',
                        borderRadius: '12px',
                        border: 'none',
                        background: jerseyCurveText ? '#10b981' : '#d1d5db',
                        position: 'relative',
                        cursor: 'pointer',
                        transition: 'background 0.2s ease'
                      }}
                    >
                      <div
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          background: 'white',
                          position: 'absolute',
                          top: '2px',
                          left: jerseyCurveText ? '22px' : '2px',
                          transition: 'left 0.2s ease',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                      />
                    </button>
                  </div>
                </div>

              </div>
            )}

            {activeTab === 'preset' && (
              <div className="customizer-preset-section">
                {/* Preset Design Categories */}
                {!selectedPresetCategory ? (
                  <div>
                    <label className="customizer-preset-label" style={{ 
                      display: 'block', 
                      fontSize: '0.875rem', 
                      fontWeight: '600', 
                      color: '#374151', 
                      marginBottom: '0.75rem' 
                    }}>
                      Choose Design Category
                    </label>
                    <div className="customizer-preset-categories" style={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      gap: '0.75rem' 
                    }}>
                      {presetDesignCategories.length === 0 && (
                        <div style={{ padding: '1rem', textAlign: 'center', color: '#6b7280' }}>
                          <p>No preset design categories available</p>
                          <p style={{ fontSize: '0.75rem', marginTop: '0.5rem' }}>
                            Check console for debugging information
                          </p>
                        </div>
                      )}
                      {presetDesignCategories.map((category, index) => {
                        // Get the first design as preview
                        const previewDesign = category.designs && category.designs.length > 0 ? category.designs[0] : null;
                        console.log(`   - Preview design:`, previewDesign);
                        
                        return (
                        <div
                          key={index}
                          onClick={() => setSelectedPresetCategory(category)}
                          style={{
                              padding: '10px',
                            border: '1px solid #e5e7eb',
                            borderRadius: '0.5rem',
                            background: 'white',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                              textAlign: 'center',
                              display: 'flex',
                              flexDirection: 'row',
                              gap: '0.75rem',
                              alignItems: 'center',
                              lineHeight: '1'
                          }}
                          onMouseEnter={(e) => {
                              e.currentTarget.style.borderColor = '#10b981';
                              e.currentTarget.style.background = '#f0fdf4';
                          }}
                          onMouseLeave={(e) => {
                              e.currentTarget.style.borderColor = '#e5e7eb';
                              e.currentTarget.style.background = 'white';
                            }}
                          >
                            {/* Preview Image */}
                            {previewDesign && previewDesign.image && (
                              <div style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '0.375rem',
                                overflow: 'hidden',
                                border: '1px solid #e5e7eb',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 0 7px 1px rgba(0, 0, 0, 0.1)'
                              }}>
                                <img 
                                  src={previewDesign.image?.src || previewDesign.image?.url} 
                                  alt={`${category.name} preview`}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain'
                                  }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                  }}
                                />
                              </div>
                            )}
                            
                            {/* Category Info */}
                            <div className="customizer-preset-category-info" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '0.25rem' }}>
                          <div style={{ fontSize: '0.875rem', fontWeight: '600', color: '#374151' }}>
                            {category.name.replace("_s_", "'s ").replace(/_/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                          </div>
                              <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                            {category.designs.length} designs
                          </div>
                        </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div>
                    <div style={{ marginBottom: '1rem' }}>
                      <Button
                        onClick={() => setSelectedPresetCategory(null)}
                        style={{
                          padding: '0.5rem 1rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '0.375rem',
                          background: 'white',
                          color: '#374151',
                          cursor: 'pointer',
                          fontSize: '0.875rem'
                        }}
                      >
                        ← Back to Categories
                      </Button>
                    </div>
                    
                    <label className="customizer-preset-label" style={{ 
                      display: 'block', 
                      fontSize: '0.875rem', 
                      fontWeight: '600', 
                      color: '#374151', 
                      marginBottom: '0.75rem' 
                    }}>
                      Choose Design from {selectedPresetCategory.name.replace("_s_", "'s ").replace(/_/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                    </label>
                    
                    <PresetDesignsGrid className="customizer-preset-designs">
                      {!selectedPresetCategory.designs || selectedPresetCategory.designs.length === 0 ? (
                        <div style={{ padding: '1rem', textAlign: 'center', color: '#6b7280' }}>
                          <p>No designs available in this category</p>
                          <p style={{ fontSize: '0.75rem', marginTop: '0.5rem' }}>
                            Category: {selectedPresetCategory.name.replace("_s_", "'s ").replace(/_/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                          </p>
                        </div>
                      ) : (
                        <>
                          {selectedPresetCategory.designs.map((design, index) => {
                            return (
                              <PresetDesignCard
                                key={index}
                          $selected={selectedPresetDesign && selectedPresetDesign.title === design.title}
                          onClick={async () => {
                            // Clear all other style states when selecting preset design
                            setCustomElements([]);
                            // Clear logo states
                            setLogoProcessingState('idle');
                            setProcessedLogoUrl(null);
                            setOriginalLogoUrl(null);
                            setProcessedBlob(null);
                            setOriginalLogoBase64(null);
                            processedLogoCanvasRef.current = null;
                            presetDesignCanvasRef.current = null;
                            // Clear text states
                            setCustomText('');
                            // Clear jersey states
                            setJerseyNumber('');
                            setJerseyText('');
                            setJerseyTextPosition('below');
                            
                            setSelectedPresetDesign(design);
                            
                            try {
                              // Process the preset design with metallic effect
                              const imageUrl = design.image?.src || design.image?.url;
                              if (imageUrl) {
                                // Store base canvas for fast color updates
                                const metallicImageUrl = await processPresetDesignWithMetallic(imageUrl, { storeBaseCanvas: true });
                                
                                // Get dynamic styles based on selected product
                                const productType = selectedProduct?.collectionHandle || 'traveler-40oz';
                                const styles = getCustomElementStyles(productType, 'design');
                                console.log("styles", styles);
                                
                                // Add the metallic preset design to canvas
                                const newElement = {
                                  type: 'image',
                                  imageUrl: metallicImageUrl,
                                  width: styles.width,
                                  height: styles.height,
                                  top: styles.top,
                                  left: styles.left,
                                  right: styles.right,
                                  margin: styles.margin,
                                  rotation: 0,
                                  isPresetDesign: true,
                                  textLength: 0
                                };
                                setCustomElements([newElement]);
                                setIsDrawerOpen(false);
                              }
                            } catch (error) {
                              console.error('Error processing preset design:', error);
                              // Get dynamic styles based on selected product
                              const productType = selectedProduct?.collectionHandle || 'traveler-40oz';
                              const styles = getCustomElementStyles(productType, 'design');

                              // Fallback to original image if processing fails
                              const newElement = {
                                type: 'image',
                                imageUrl: design.image?.src || design.image?.url,
                                width: styles.width,
                                height: styles.height,
                                top: styles.top,
                                left: styles.left,
                                right: styles.right,
                                margin: styles.margin,
                                rotation: 0,
                                isPresetDesign: true,
                                textLength: 0
                              };
                              setCustomElements([newElement]);
                              setIsDrawerOpen(false);
                            }
                          }}
                        >
                          <img 
                            src={design.image?.src || design.image?.url} 
                            alt={design.title}
                            style={{
                              width: '100%',
                              height: 'auto',
                              borderRadius: '0.25rem',
                              marginBottom: '0.5rem'
                            }}
                          />
                          <div style={{ fontSize: '0.75rem', fontWeight: '500', color: '#374151' }}>
                            {design.title}
                          </div>
                          {/* <div style={{ fontSize: '0.625rem', color: '#10b981', fontWeight: '600' }}>
                            ${design.price}
                          </div> */}
                              </PresetDesignCard>
                            );
                          })}
                        </>
                      )}
                    </PresetDesignsGrid>
                  </div>
                )}
              </div>
            )}
          </DrawerContent>
        </SlideDrawer>
      </ControlsSection>

      {/* Terms and Conditions Modal */}
      {showTermsModal && (
        <TermsModalOverlay onClick={handleTermsCancel}>
          <TermsModalContent onClick={(e) => e.stopPropagation()}>
            <TermsModalHeader>
              <h2>Please confirm</h2>
              <TermsModalCloseButton onClick={handleTermsCancel}>
                ×
              </TermsModalCloseButton>
            </TermsModalHeader>
            
            <TermsModalBody>

              <h3>All sales of customized products are final:</h3>
              <ul>
                <li>Customized items are non-refundable and cannot be canceled once you have submitted the order.</li>
                <li>No edits or changes can be made once you have submitted your order.</li>
                <li>Any adjustments or resizing should be made prior to submitting the order.</li>
              </ul>

              <h3>"Upload Design" customization quality is dependent on the artwork submitted:</h3>
              <ul>
                <li>Photographs and QR codes are not compatible with laser engraving and are not recommended.</li>
                <li>Check for stray marks or dots and crop these out or they will be included in your customization.</li>
              </ul>


              <h3>By using this service, you confirm that your submitted text and artwork you have selected for customization:</h3>
              <ul>
                <li>does not infringe on any trademark, copyright, design rights, or other proprietary rights of any third party and does not otherwise violate anyone's rights or other categories listed in our FAQ.</li>
                <li>is not unlawful, harmful, threatening, tortious, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable.</li>
                <li>does not include any sensitive personal information (e.g., driver's license, SSN, payment card info, etc.).</li>
                <li>does not otherwise violate anyone's rights or other categories listed in our FAQ.</li>
              </ul>

              <p>All custom orders will be reviewed. If any of the above terms are violated, your full custom order will be cancelled.</p>

              <p>If you need any assistance with a custom drinkware order, including if you want to place an order for a trademark or copyright image that you have authorization for or have questions, please reach out to our service team prior to placing your order. <a href="mailto:service@thehydrojug.com" style={{ color: '#0066cc', textDecoration: 'underline' }}>service@thehydrojug.com</a></p>

              <p>For bulk orders, please check out our <a href="https://wholesale.thehydrojug.com" target="_blank">Corporate Sales website</a> for info including quotes.</p>
            </TermsModalBody>

            <TermsModalFooter>
              <TermsCheckboxContainer>
                <input 
                  type="checkbox" 
                  id="terms-checkbox"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                <label htmlFor="terms-checkbox">I accept these terms and conditions</label>
              </TermsCheckboxContainer>
              
              <TermsButtonContainer>
                <TermsButton className="cancel" onClick={handleTermsCancel}>
                  Cancel
                </TermsButton>
                <TermsButton 
                  className="accept" 
                  disabled={!termsAccepted}
                  onClick={handleTermsAccept}
                >
                  Accept
                </TermsButton>
              </TermsButtonContainer>
            </TermsModalFooter>
          </TermsModalContent>
        </TermsModalOverlay>
      )}

      {/* Moderation Overlay */}
      {/* {isModerating && (
        <ModerationOverlay>
          <ModerationContent>
            <Spinner />
            <h2 style={{ margin: '0 0 1rem 0', fontSize: '1.5rem', fontWeight: '600', color: '#333' }}>
              Moderating Image
            </h2>
            <p style={{ margin: '0', fontSize: '1rem', color: '#666', lineHeight: '1.6' }}>
              Please wait while we review your image for compliance. This may take a few moments.
            </p>
            <p style={{ margin: '1rem 0 0 0', fontSize: '0.875rem', color: '#999', fontStyle: 'italic' }}>
              Please do not refresh or navigate away from this page.
            </p>
          </ModerationContent>
        </ModerationOverlay>
      )} */}

      {/* Moderation Error Modal */}
      {showModerationErrorModal && (
        <TermsModalOverlay onClick={() => setShowModerationErrorModal(false)}>
          <TermsModalContent onClick={(e) => e.stopPropagation()}>
            <TermsModalHeader>
              <h2>⚠️ Image Flagged</h2>
              <TermsModalCloseButton onClick={() => setShowModerationErrorModal(false)}>
                ×
              </TermsModalCloseButton>
            </TermsModalHeader>
            
            <TermsModalBody>
              <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '1rem' }}>
                This image was flagged for violating our terms. The product was not added to cart.
              </p>
              <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '1rem' }}>
                Please try again with a different image.
              </p>
              <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
                If you think this was a mistake, reach out to us at <a href="mailto:service@thehydrojug.com" style={{ color: '#0066cc', textDecoration: 'underline' }}>service@thehydrojug.com</a>
              </p>
            </TermsModalBody>

            <TermsModalFooter>
              <TermsButtonContainer style={{ justifyContent: 'center' }}>
                <TermsButton 
                  className="accept" 
                  onClick={() => setShowModerationErrorModal(false)}
                  style={{ minWidth: '120px' }}
                >
                  OK
                </TermsButton>
              </TermsButtonContainer>
            </TermsModalFooter>
          </TermsModalContent>
        </TermsModalOverlay>
      )}

      {/* Loading Modal */}
      {showLoadingModal && (
        <LoadingModalOverlay>
          <LoadingModalContent>
            <LoadingModalHeader>
              <h2>Saving your upload, please wait</h2>
            </LoadingModalHeader>
            
            <LoadingProgressContainer>
              <LoadingPercentage>{uploadProgress}%</LoadingPercentage>
              <LoadingProgressBar>
                <div className="progress" style={{ width: `${uploadProgress}%` }} />
              </LoadingProgressBar>
            </LoadingProgressContainer>
          </LoadingModalContent>
        </LoadingModalOverlay>
      )}

      {/* Logo Review Modal */}
      {showReviewModal && processedLogoUrl && (
        <ReviewOverlay>
          <ReviewHeader>
            <p>Review your design carefully. Everything shown here will be printed.</p>
          </ReviewHeader>
          
          <ReviewToolbar>
            <ToolbarButton
              className={invertEtch ? 'active' : ''}
              onClick={() => {
                const newInvert = !invertEtch;
                setInvertEtch(newInvert);
                if (originalLogoUrl) {
                  // Use requestAnimationFrame to prevent UI freezing
                  requestAnimationFrame(() => {
                    processImageLocally(originalLogoUrl, { 
                      thresholdValue, 
                      invert: newInvert,
                      keepDrawerOpen: true,
                      preview: true // Use 2x resolution for faster interaction
                    });
                  });
                }
              }}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
              </svg>
              INVERT
            </ToolbarButton>
            
          </ReviewToolbar>
          
          {/* Threshold Slider (always visible) */}
          <div style={{ 
            padding: '0 2rem 1rem', 
            background: '#e8f0f5',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <div style={{ 
              background: 'white', 
              padding: '1rem 1.5rem', 
              borderRadius: '0.5rem',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              width: '100%',
              maxWidth: '400px'
            }}>
              <div style={{ textAlign: 'center', marginBottom: '0.25rem' }}>
                <span style={{ fontSize: '0.8125rem', color: '#4b5563' }}>Move the slider to modify your logo's appearance.</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>{invertEtch ? 'Heavy' : 'Light'}</span>
                <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>{invertEtch ? 'Light' : 'Heavy'}</span>
              </div>
              <input
                type="range"
                min="25"
                max="230"
                step="15"
                value={thresholdValue}
                onChange={(e) => {
                  const newValue = Number(e.target.value);
                  setThresholdValue(newValue);
                  handleThresholdChangeFullResDebounced(newValue); // Use full resolution in review modal
                }}
                style={{
                  width: '100%',
                  height: '6px',
                  borderRadius: '3px',
                  background: '#e5e7eb',
                  outline: 'none',
                  cursor: 'pointer'
                }}
              />
              {invertEtch && (
                <div style={{ 
                  textAlign: 'center', 
                  marginTop: '0.75rem',
                  padding: '0.375rem 0.75rem',
                  background: '#1e3a5f',
                  borderRadius: '0.25rem',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.375rem',
                  width: '100%'
                }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                    <path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                  </svg>
                  <span style={{ fontSize: '0.75rem', color: 'white', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.025em' }}>Inverted</span>
                </div>
              )}
            </div>
          </div>
          
          <ReviewImageContainer>
            <ReviewImageWrapper>
              <ReviewImage src={processedLogoUrl} alt="Processed logo preview" />
            </ReviewImageWrapper>
          </ReviewImageContainer>
          
          <ReviewFooter>
            <ReviewButton
              onClick={async () => {
                // Cancel - close modal and reset settings, but keep image in drawer
                // The logo should NOT appear on the bottle until Accept is clicked
                setShowReviewModal(false);
                setShowThresholdSlider(false);
                
                // Clear any rendering from the bottle (nothing should show until Accept)
                setCustomElements([]);
                
                // Reset threshold and invert to defaults
                const defaultThreshold = 128;
                const defaultInvert = false;
                setThresholdValue(defaultThreshold);
                setInvertEtch(defaultInvert);
                
                // Re-process the image with default settings so drawer preview matches defaults
                // skipModal prevents the review modal from re-opening immediately
                if (originalLogoUrl) {
                  await processImageLocally(originalLogoUrl, { 
                    thresholdValue: defaultThreshold, 
                    invert: defaultInvert,
                    keepDrawerOpen: true,
                    preview: true,  // Use preview mode for consistent sizing
                    skipModal: true  // Don't re-open the modal
                  });
                }
              }}
            >
              CANCEL
            </ReviewButton>
            <ReviewButton
              $primary
              onClick={() => {
                // Accept - add to canvas and close modal
                setShowReviewModal(false);
                setShowThresholdSlider(false);
                if (processedLogoUrl) {
                  addProcessedLogoToCanvas(processedLogoUrl, { keepDrawerOpen: true, preserveTransform: true });
                }
              }}
            >
              ACCEPT
            </ReviewButton>
          </ReviewFooter>
        </ReviewOverlay>
      )}
    </CustomizerContainer>
  );
}

export default component((node, ctx) => {
  const element = <HydroCustomizer node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    root.unmount();
  };
});
